function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-166"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.54,91.76v15.51a4,4,0,0,1-1.82,3.15l-16.28,9.52c-1,.58-1.82.11-1.82-1V103.38a4,4,0,0,1,1.82-3.15c4.45-2.56,11.84-7,16.28-9.52C191.73,90.13,192.54,90.6,192.54,91.76Z",
    style: {
      fill: "#3DBA61"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-166"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-166",
    cx: 250,
    cy: 352.38,
    rx: 231.53,
    ry: 130.13,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-166"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-166",
    cx: 392.84,
    cy: 300.76,
    rx: 53.26,
    ry: 30.75,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-166",
    d: "M417.61,388.43a1.2,1.2,0,0,0-.16-.27l-.14-.18a1.45,1.45,0,0,0-.17-.19,1,1,0,0,0-.18-.17,3.61,3.61,0,0,0-.67-.48L190.78,256.94a8.26,8.26,0,0,0-7.47,0L72.74,320.77c-.16.1-.31.18-.44.28l-.15.12a2.89,2.89,0,0,0-.63.7,1.14,1.14,0,0,0-.1.19.81.81,0,0,0-.12.29.86.86,0,0,0-.06.23,1.5,1.5,0,0,0,0,.37,2.11,2.11,0,0,0,0,.26,1.38,1.38,0,0,0,.08.29,1.18,1.18,0,0,0,.12.28,3.23,3.23,0,0,0,1.32,1.3l225.51,130.2a6.83,6.83,0,0,0,2.23.76,10.73,10.73,0,0,0,1.51.13,10.47,10.47,0,0,0,1.5-.12,2.36,2.36,0,0,0,.49-.1,7.38,7.38,0,0,0,1.35-.45l.4-.22,110.56-63.83C417.71,390.63,418.15,389.46,417.61,388.43Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-166",
    points: "72.29 384.85 204.51 461.24 221.65 461.24 294.49 419.19 294.49 409.29 162.27 332.91 145.13 332.91 72.29 374.96 72.29 384.85",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-166",
    points: "235.7 254.49 280.46 280.37 315.17 260.33 270.11 234.28 235.7 254.49",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-166",
    points: "272.63 243.74 316.22 268.86 345.52 252.02 301.63 226.73 272.63 243.74",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ticket--inject-166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--ticket--inject-166"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "294.49 408.41 294.49 398.52 165.95 324.3 148.81 324.3 75.97 366.35 75.97 376.25 75.97 376.25 75.97 378.72 204.51 452.94 221.65 452.94 294.49 410.89 294.49 408.41 294.49 408.41",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.49 408.41 294.49 398.52 165.95 324.3 148.81 324.3 75.97 366.35 75.97 376.25 75.97 376.25 75.97 378.72 204.51 452.94 221.65 452.94 294.49 410.89 294.49 408.41 294.49 408.41",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.65 450.46 294.49 408.41 294.49 410.89 221.65 452.94 221.65 450.46",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.97 376.25 204.51 450.46 204.51 452.94 75.97 378.72 75.97 376.25",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.51,
    y: 450.46,
    width: 17.14,
    height: 2.47,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.97 376.25 204.51 450.46 221.65 450.46 294.49 408.41 294.49 398.52 165.95 324.3 148.81 324.3 75.97 366.35 75.97 376.25",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.97 376.25 204.51 450.46 221.65 450.46 294.49 408.41 294.49 398.52 165.95 324.3 148.81 324.3 75.97 366.35 75.97 376.25",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.97 376.25 204.51 450.46 221.65 450.46 294.49 408.41 294.49 398.52 165.95 324.3 148.81 324.3 75.97 366.35 75.97 376.25",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.97 427.77 294.49 408.41 294.49 398.52 165.95 324.3 148.81 324.3 115.28 343.66 260.97 427.77",
    style: {
      fill: "#3DBA61",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.51 392.9 218.5 410.22 219.71 409.52 189.72 392.21 188.51 392.9",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.83 387.52 227.82 404.84 229.03 404.14 199.03 386.83 197.83 387.52",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.65 383.01 235.64 400.32 236.43 399.88 206.44 382.56 205.65 383.01",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.3 390.14 223.29 407.46 223.89 407.11 193.9 389.79 193.3 390.14",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.87 386.35 229.87 403.66 230.47 403.31 200.47 386 199.87 386.35",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.11 383.9 234.1 401.21 234.71 400.87 204.71 383.55 204.11 383.9",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.65 391.67 220.65 408.98 222.79 407.75 192.79 390.43 190.65 391.67",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.94 389.19 224.93 406.51 227.07 405.27 197.08 387.96 194.94 389.19",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.37 385.48 231.36 402.8 232.83 401.96 202.83 384.64 201.37 385.48",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.63 404.38 198.62 421.7 199.83 421 169.83 403.69 168.63 404.38",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.94 399 207.94 416.32 209.14 415.62 179.15 398.31 177.94 399",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.76 394.49 215.76 411.81 216.97 411.11 186.97 393.79 185.76 394.49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.41 401.62 203.41 418.94 204.01 418.59 174.02 401.27 173.41 401.62",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.93 397.84 209.92 415.16 210.53 414.81 180.53 397.5 179.93 397.84",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.23 395.38 214.22 412.69 214.82 412.35 184.83 395.03 184.23 395.38",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.77 403.15 200.76 420.46 202.35 419.55 172.35 402.24 170.77 403.15",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.05 400.67 205.04 417.99 206.79 416.99 176.8 399.67 175.05 400.67",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.55 396.92 211.55 414.24 213.22 413.3 183.23 395.99 181.55 396.92",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.64 381.86 237.63 399.18 238.84 398.48 208.84 381.16 207.64 381.86",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.84 380.59 239.83 397.91 240.44 397.56 210.44 380.25 209.84 380.59",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.92 378.23 243.91 395.55 244.52 395.2 214.52 377.89 213.92 378.23",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.59 379.58 241.59 396.9 243.31 395.9 213.32 378.58 211.59 379.58",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.38,407.47a3.49,3.49,0,0,0-1-.37,4.31,4.31,0,0,0-1.08-.11,4.74,4.74,0,0,0-1.11.17,4.8,4.8,0,0,0-1.05.42l-.45-1.43a.06.06,0,0,0,0,0,.11.11,0,0,0,0,0,.4.4,0,0,0-.22-.06.44.44,0,0,0-.23.06l-.74.42c-.07.05-.11.09-.11.13s0,.08,0,.11l.65,2.18a2.67,2.67,0,0,0,.25.58,1.79,1.79,0,0,0,.63.57,3.7,3.7,0,0,0,1,.38,4.55,4.55,0,0,0,1.11.1,4.81,4.81,0,0,0,1.12-.16,4.86,4.86,0,0,0,1-.44,2.71,2.71,0,0,0,.76-.61,1.22,1.22,0,0,0,.29-.65.94.94,0,0,0-.18-.63A2,2,0,0,0,253.38,407.47Zm-1.24,1.88a2.23,2.23,0,0,1-1.11.3,2,2,0,0,1-1-.24.67.67,0,0,1-.41-.57c0-.22.19-.44.54-.64a2.29,2.29,0,0,1,1.11-.32,2,2,0,0,1,1,.24.68.68,0,0,1,.42.58C252.68,408.92,252.5,409.14,252.14,409.35Zm-9.24,5,.71-.41c.06,0,.09-.08.09-.13s0-.09-.09-.13l-.58-.34a.52.52,0,0,0-.23-.05.51.51,0,0,0-.22.05l-.71.41-3.28-1.89a.41.41,0,0,0-.23-.06.4.4,0,0,0-.22.06l-.62.36a.25.25,0,0,0-.13.31l.62,3.26.06.18a.27.27,0,0,0,.15.15l.58.34a.51.51,0,0,0,.44,0l2.55-1.47,1,.57a.38.38,0,0,0,.22.05.32.32,0,0,0,.22-.05l.67-.38c.06,0,.09-.08.09-.13s0-.09-.09-.13Zm-3.54.86L239,413.4l1.76,1ZM218,427.7l-.34-.2-.38-.23-.39-.22-.35-.19a6.08,6.08,0,0,0-1-.43,4,4,0,0,0-1.09-.19,3.76,3.76,0,0,0-1.14.12,4.36,4.36,0,0,0-1.18.49,2.52,2.52,0,0,0-.85.69.94.94,0,0,0-.19.66,1.17,1.17,0,0,0,.35.64,3.91,3.91,0,0,0,.74.59c.2.13.43.27.7.42s.51.29.73.4a5.66,5.66,0,0,0,1,.43,4,4,0,0,0,1.09.19,4.08,4.08,0,0,0,1.14-.11,4.74,4.74,0,0,0,1.19-.5,2.82,2.82,0,0,0,.84-.68.91.91,0,0,0,.21-.66,1.21,1.21,0,0,0-.33-.63A3.91,3.91,0,0,0,218,427.7Zm-1,2a1.9,1.9,0,0,1-1.14.28,3.37,3.37,0,0,1-1.21-.36c-.22-.11-.45-.24-.7-.39s-.48-.28-.68-.41a1.4,1.4,0,0,1-.63-.69c-.05-.22.11-.44.49-.66a1.91,1.91,0,0,1,1.15-.28,3.39,3.39,0,0,1,1.2.36c.22.11.45.24.7.39s.48.28.68.41a1.31,1.31,0,0,1,.63.69C217.49,429.23,217.32,429.45,216.94,429.67Zm42.45-24.53a1.41,1.41,0,0,0-.59-.53,2.76,2.76,0,0,0-.75-.31,3.3,3.3,0,0,0-.83-.09,3.53,3.53,0,0,0-.85.1,3.93,3.93,0,0,0-.86.28l-.06-1.43a.78.78,0,0,0,0-.14.19.19,0,0,0-.11-.14l-.58-.33a.43.43,0,0,0-.44,0l-3.6,2.08a.14.14,0,0,0-.09.13.14.14,0,0,0,.09.12l.58.34a.51.51,0,0,0,.44,0l2.27-1.31.06,1.36a.89.89,0,0,0,0,.15.18.18,0,0,0,.1.13l.59.34a.51.51,0,0,0,.44,0l.68-.4a3.25,3.25,0,0,1,1-.37,1.18,1.18,0,0,1,.84.13c.25.14.34.31.26.51a1.28,1.28,0,0,1-.6.58q-.3.17-.54.27a3.67,3.67,0,0,1-.46.13,1.63,1.63,0,0,1-.37,0,1.66,1.66,0,0,1-.32,0l-.26,0a.41.41,0,0,0-.19,0l-.65.37a.2.2,0,0,0-.1.13c0,.05,0,.09.1.13a2.86,2.86,0,0,0,.71.21,3.87,3.87,0,0,0,.91,0,5.37,5.37,0,0,0,1.06-.21,5.08,5.08,0,0,0,1.14-.5,3.16,3.16,0,0,0,.76-.58,1.48,1.48,0,0,0,.35-.61A.81.81,0,0,0,259.39,405.14ZM234,418.74a3.56,3.56,0,0,0-1-.38,4.14,4.14,0,0,0-1.05-.08,4.71,4.71,0,0,0-1.05.18,5,5,0,0,0-1,.43l-.34.21a1.44,1.44,0,0,0-.33.32l-1-.66,2.31-1.34a.14.14,0,0,0,.09-.12.15.15,0,0,0-.09-.13l-.59-.34a.51.51,0,0,0-.44,0l-3.09,1.79a.14.14,0,0,0-.09.12.15.15,0,0,0,.09.13l2.54,1.75a.43.43,0,0,0,.44,0l.76-.43a.4.4,0,0,0,.15-.13,1.09,1.09,0,0,1,.08-.15.57.57,0,0,1,.15-.18,1.44,1.44,0,0,1,.35-.25,2.26,2.26,0,0,1,1-.29,1.58,1.58,0,0,1,.9.19q.45.25.42.57a.87.87,0,0,1-.5.58,3.6,3.6,0,0,1-.39.2,1.93,1.93,0,0,1-.41.12,2,2,0,0,1-.43,0,2,2,0,0,1-.47-.09.46.46,0,0,0-.23,0,.39.39,0,0,0-.2.05l-.67.39a.17.17,0,0,0-.1.12.13.13,0,0,0,.1.13,2.84,2.84,0,0,0,.76.27,4,4,0,0,0,.93.07,4.51,4.51,0,0,0,1-.19,5.18,5.18,0,0,0,1.1-.48,3.75,3.75,0,0,0,.73-.55,1.13,1.13,0,0,0,.33-.6.84.84,0,0,0-.15-.62A2.13,2.13,0,0,0,234,418.74Zm14.2-8.2a3.08,3.08,0,0,0-1-.38,4,4,0,0,0-1-.08,4.62,4.62,0,0,0-1.05.18,5.36,5.36,0,0,0-1,.42l-.34.22a1.27,1.27,0,0,0-.34.31l-1-.65,2.31-1.34a.15.15,0,0,0,.09-.13.14.14,0,0,0-.09-.12l-.58-.34a.4.4,0,0,0-.22-.05.38.38,0,0,0-.22.05l-3.1,1.78c-.06,0-.09.08-.09.13s0,.09.1.13l2.53,1.75a.43.43,0,0,0,.23.05.4.4,0,0,0,.22-.05l.75-.44a.36.36,0,0,0,.16-.13s.05-.09.07-.14a.77.77,0,0,1,.15-.19,1.57,1.57,0,0,1,.36-.24,2.11,2.11,0,0,1,1-.29,1.52,1.52,0,0,1,.9.19c.3.17.43.36.41.57s-.19.4-.5.58l-.38.2a3.17,3.17,0,0,1-.41.12,1.6,1.6,0,0,1-.44,0,1.54,1.54,0,0,1-.46-.08.5.5,0,0,0-.24,0,.42.42,0,0,0-.2.05l-.66.38c-.06,0-.1.08-.1.13s0,.1.1.13a2.84,2.84,0,0,0,.76.27,3.45,3.45,0,0,0,.92.06,3.92,3.92,0,0,0,1-.18,5.31,5.31,0,0,0,1.11-.49,3.64,3.64,0,0,0,.73-.54,1.12,1.12,0,0,0,.33-.61.87.87,0,0,0-.16-.62A2,2,0,0,0,248.17,410.54Zm-14.36,4.09a.51.51,0,0,0-.22-.05.48.48,0,0,0-.22.05l-.65.37a.19.19,0,0,0-.1.12s0,.09-.05.13l-.37,1.84a.14.14,0,0,0,.06.14.4.4,0,0,0,.21.07l.87.05a.47.47,0,0,0,.24,0,.15.15,0,0,0,.11-.11L234,416l4.06,2.35a.51.51,0,0,0,.44,0l.67-.39a.14.14,0,0,0,.09-.12.15.15,0,0,0-.09-.13Zm-3.89,7.71a.43.43,0,0,0-.44,0l-2.29,1.32.13-1.68a1.6,1.6,0,0,0,0-.52,1,1,0,0,0-.12-.37,1,1,0,0,0-.26-.28,3.75,3.75,0,0,0-.36-.24,3,3,0,0,0-.77-.31,4,4,0,0,0-1-.13,4.39,4.39,0,0,0-1.06.11,3.66,3.66,0,0,0-1.06.42,2.14,2.14,0,0,0-.65.54,1.13,1.13,0,0,0-.26.6,1,1,0,0,0,.14.59,1.55,1.55,0,0,0,.51.51.43.43,0,0,0,.44,0l.65-.37a.18.18,0,0,0,.09-.12q0-.07-.06-.15a.78.78,0,0,1-.27-.5c0-.17.14-.34.45-.51a1.71,1.71,0,0,1,.91-.26,1.68,1.68,0,0,1,.78.21,1.26,1.26,0,0,1,.31.26.46.46,0,0,1,.08.42l-.33,2.63a.31.31,0,0,0,0,.16c0,.07.07.13.16.19l.5.29a.51.51,0,0,0,.44,0l3.84-2.22a.15.15,0,0,0,.09-.13c0-.05,0-.09-.09-.13Zm-6,2.44a2.77,2.77,0,0,0-.94-.33,3.89,3.89,0,0,0-1.08,0,.82.82,0,0,0-.13-.5,1.46,1.46,0,0,0-.5-.43,2.53,2.53,0,0,0-.85-.31,3.82,3.82,0,0,0-1-.06,4.29,4.29,0,0,0-1,.18,4.62,4.62,0,0,0-.94.41,2.74,2.74,0,0,0-.7.54,1.18,1.18,0,0,0-.31.58.73.73,0,0,0,.1.55,1.34,1.34,0,0,0,.53.49,2.9,2.9,0,0,0,1.6.37.75.75,0,0,0,.06.62,1.33,1.33,0,0,0,.58.54,2.72,2.72,0,0,0,.89.33,3.46,3.46,0,0,0,1,.06,4.75,4.75,0,0,0,1.08-.2,5.57,5.57,0,0,0,1.07-.46,3.49,3.49,0,0,0,.81-.62,1.43,1.43,0,0,0,.35-.63.8.8,0,0,0-.11-.58A1.54,1.54,0,0,0,223.88,424.78Zm-4.06.28a2.32,2.32,0,0,1-.39.18,2.26,2.26,0,0,1-.43.11,1.48,1.48,0,0,1-.42,0,.77.77,0,0,1-.37-.12A.42.42,0,0,1,218,425a.29.29,0,0,1,0-.24,1,1,0,0,1,.18-.25,1.65,1.65,0,0,1,.32-.23,2.32,2.32,0,0,1,.39-.18,3.89,3.89,0,0,1,.43-.11,1.48,1.48,0,0,1,.42,0,1.07,1.07,0,0,1,.37.12.42.42,0,0,1,.21.21.29.29,0,0,1,0,.24.69.69,0,0,1-.18.25A1.31,1.31,0,0,1,219.82,425.06Zm3.16.9a1,1,0,0,1-.22.3,2.42,2.42,0,0,1-.39.27,2.62,2.62,0,0,1-.48.22,1.91,1.91,0,0,1-.51.13,2.12,2.12,0,0,1-.5,0,1.21,1.21,0,0,1-.43-.14.42.42,0,0,1-.23-.25.39.39,0,0,1,0-.28,1,1,0,0,1,.23-.3,2.34,2.34,0,0,1,.38-.28c.15-.08.31-.15.48-.22a3.3,3.3,0,0,1,.52-.13,2,2,0,0,1,.49,0,1.2,1.2,0,0,1,.43.13.49.49,0,0,1,.23.25A.37.37,0,0,1,223,426Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.44 387.73 143.1 379.49 135.95 383.67 135.98 358.94 178.8 358.93 171.56 363.05 185.91 371.3 157.44 387.73",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.8 358.93 141.76 358.94 174.53 377.86 185.91 371.3 171.56 363.05 178.8 358.93",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.79,415l1,.57a.38.38,0,0,0,.22.05.32.32,0,0,0,.22-.05l.67-.38c.06,0,.09-.08.09-.13s0-.09-.09-.13l-1-.57.71-.41c.06,0,.09-.08.09-.13s0-.09-.09-.13l-.58-.34a.52.52,0,0,0-.23-.05.51.51,0,0,0-.22.05l-.71.41-3.28-1.89a.41.41,0,0,0-.23-.06.4.4,0,0,0-.22.06l-.62.36a.25.25,0,0,0-.13.31l.34,1.8,2.6,1.5Zm-1-.6-1.4.82L239,413.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,412.33l-.38.2a3.17,3.17,0,0,1-.41.12,1.6,1.6,0,0,1-.44,0,1.54,1.54,0,0,1-.46-.08.5.5,0,0,0-.24,0,.42.42,0,0,0-.2.05l-.66.38c-.06,0-.1.08-.1.13s0,.1.1.13a2.84,2.84,0,0,0,.76.27,3.45,3.45,0,0,0,.92.06,3.92,3.92,0,0,0,1-.18,5.31,5.31,0,0,0,1.11-.49,3.64,3.64,0,0,0,.73-.54,1.12,1.12,0,0,0,.33-.61.87.87,0,0,0-.16-.62,2,2,0,0,0-.73-.61,3.08,3.08,0,0,0-1-.38,4,4,0,0,0-1-.08,4.62,4.62,0,0,0-1.05.18,5.36,5.36,0,0,0-1,.42l-.34.22a1.27,1.27,0,0,0-.34.31l-1-.65,2.31-1.34a.15.15,0,0,0,.09-.13.14.14,0,0,0-.09-.12l-.58-.34a.4.4,0,0,0-.22-.05.38.38,0,0,0-.22.05l-3.1,1.78c-.06,0-.09.08-.09.13s0,.09.1.13l2.53,1.75a.43.43,0,0,0,.23.05.4.4,0,0,0,.22-.05l.75-.44a.36.36,0,0,0,.16-.13s.05-.09.07-.14a.77.77,0,0,1,.15-.19,1.57,1.57,0,0,1,.36-.24,2.11,2.11,0,0,1,1-.29,1.52,1.52,0,0,1,.9.19c.3.17.43.36.41.57S247.28,412.15,247,412.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,410.54a4.81,4.81,0,0,0,1.12-.16,4.86,4.86,0,0,0,1-.44,2.71,2.71,0,0,0,.76-.61,1.22,1.22,0,0,0,.29-.65.94.94,0,0,0-.18-.63,2,2,0,0,0-.66-.58,3.49,3.49,0,0,0-1-.37,4.31,4.31,0,0,0-1.08-.11,4.74,4.74,0,0,0-1.11.17,4.8,4.8,0,0,0-1.05.42l-.45-1.43a.06.06,0,0,0,0,0,.11.11,0,0,0,0,0,.4.4,0,0,0-.22-.06.44.44,0,0,0-.23.06l-.74.42c-.07.05-.11.09-.11.13s0,.08,0,.11l.65,2.18a2.67,2.67,0,0,0,.25.58,1.79,1.79,0,0,0,.63.57,3.7,3.7,0,0,0,1,.38A4.55,4.55,0,0,0,251,410.54Zm-1.39-1.7c0-.22.19-.44.54-.64a2.29,2.29,0,0,1,1.11-.32,2,2,0,0,1,1,.24.68.68,0,0,1,.42.58c0,.22-.18.44-.54.65a2.23,2.23,0,0,1-1.11.3,2,2,0,0,1-1-.24A.67.67,0,0,1,249.61,408.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.8,404.61a2.76,2.76,0,0,0-.75-.31,3.3,3.3,0,0,0-.83-.09,3.53,3.53,0,0,0-.85.1,3.93,3.93,0,0,0-.86.28l-.06-1.43a.78.78,0,0,0,0-.14.19.19,0,0,0-.11-.14l-.58-.33a.43.43,0,0,0-.44,0l-3.6,2.08a.14.14,0,0,0-.09.13.14.14,0,0,0,.09.12l.58.34a.51.51,0,0,0,.44,0l2.27-1.31.06,1.36a.89.89,0,0,0,0,.15.18.18,0,0,0,.1.13l.59.34a.51.51,0,0,0,.44,0l.68-.4a3.25,3.25,0,0,1,1-.37,1.18,1.18,0,0,1,.84.13c.25.14.34.31.26.51a1.28,1.28,0,0,1-.6.58q-.3.17-.54.27a3.67,3.67,0,0,1-.46.13,1.63,1.63,0,0,1-.37,0,1.66,1.66,0,0,1-.32,0l-.26,0a.41.41,0,0,0-.19,0l-.65.37a.2.2,0,0,0-.1.13c0,.05,0,.09.1.13a2.86,2.86,0,0,0,.71.21,3.87,3.87,0,0,0,.91,0,5.37,5.37,0,0,0,1.06-.21,5.08,5.08,0,0,0,1.14-.5,3.16,3.16,0,0,0,.76-.58,1.48,1.48,0,0,0,.35-.61.81.81,0,0,0-.1-.6A1.41,1.41,0,0,0,258.8,404.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.18,343.27a3.42,3.42,0,0,0-1-.37,4.44,4.44,0,0,0-1.09-.11A4.74,4.74,0,0,0,139,343a4.8,4.8,0,0,0-1,.42l-.44-1.43a.06.06,0,0,0,0,0s0,0-.06-.05a.51.51,0,0,0-.44,0l-.74.43c-.08,0-.11.09-.11.13a.36.36,0,0,0,0,.11l.64,2.18a2.72,2.72,0,0,0,.26.58,1.79,1.79,0,0,0,.63.57,3.57,3.57,0,0,0,1,.38,4.51,4.51,0,0,0,1.1.1,4.74,4.74,0,0,0,1.12-.17,4.29,4.29,0,0,0,1.06-.43,2.83,2.83,0,0,0,.75-.61,1.2,1.2,0,0,0,.3-.65,1,1,0,0,0-.19-.63A2,2,0,0,0,142.18,343.27ZM141,345.14a2.18,2.18,0,0,1-1.12.31,2,2,0,0,1-1-.24c-.28-.16-.42-.35-.41-.57s.18-.44.54-.65a2.38,2.38,0,0,1,1.11-.31,2,2,0,0,1,1,.24.68.68,0,0,1,.42.58C141.48,344.72,141.31,344.94,141,345.14Zm-9.24,5,.7-.41c.06,0,.1-.08.09-.13s0-.09-.09-.13l-.58-.34a.51.51,0,0,0-.44,0l-.71.41-3.29-1.9a.51.51,0,0,0-.44,0l-.63.36a.28.28,0,0,0-.13.32l.63,3.26a.78.78,0,0,0,.05.18.31.31,0,0,0,.15.15l.58.34a.56.56,0,0,0,.23.05.48.48,0,0,0,.22-.05l2.55-1.47,1,.57a.4.4,0,0,0,.22.05.41.41,0,0,0,.23-.05l.66-.38c.06,0,.09-.08.09-.13a.15.15,0,0,0-.09-.13Zm-3.55.85-.35-1.82,1.76,1ZM106.75,363.5l-.33-.21-.39-.22-.38-.22-.36-.2a6.18,6.18,0,0,0-1-.42,4,4,0,0,0-1.08-.19,3.76,3.76,0,0,0-1.14.12,4.37,4.37,0,0,0-1.19.48,2.71,2.71,0,0,0-.84.7.89.89,0,0,0-.19.66,1.1,1.1,0,0,0,.34.63,3.94,3.94,0,0,0,.75.6l.69.42c.27.16.51.29.73.4a5.76,5.76,0,0,0,1,.43,4.37,4.37,0,0,0,1.08.19,3.69,3.69,0,0,0,1.14-.12,4.11,4.11,0,0,0,1.19-.49,2.89,2.89,0,0,0,.85-.68.93.93,0,0,0,.2-.66,1.05,1.05,0,0,0-.33-.63A3.61,3.61,0,0,0,106.75,363.5Zm-1,2a1.86,1.86,0,0,1-1.14.28,3.27,3.27,0,0,1-1.2-.36l-.71-.39-.67-.41a1.31,1.31,0,0,1-.63-.69c-.06-.22.11-.44.49-.66A2,2,0,0,1,103,363a3.3,3.3,0,0,1,1.2.37c.22.11.46.24.71.39s.48.28.67.41a1.38,1.38,0,0,1,.64.69C106.29,365,106.13,365.25,105.74,365.47Zm42.46-24.53a1.55,1.55,0,0,0-.59-.53,3,3,0,0,0-.76-.31,3.75,3.75,0,0,0-.82-.1,5,5,0,0,0-.86.1,4.49,4.49,0,0,0-.85.29l-.07-1.43a.71.71,0,0,0,0-.14.21.21,0,0,0-.11-.14l-.58-.33a.4.4,0,0,0-.22-.06.41.41,0,0,0-.23.06l-3.6,2.08a.14.14,0,0,0-.09.12.15.15,0,0,0,.09.13l.59.34a.48.48,0,0,0,.22.05.51.51,0,0,0,.22-.05l2.27-1.31.06,1.36a.81.81,0,0,0,0,.15.2.2,0,0,0,.11.13l.58.34a.52.52,0,0,0,.23.05.51.51,0,0,0,.22-.05l.68-.4a3.16,3.16,0,0,1,1-.37,1.15,1.15,0,0,1,.84.13c.25.14.33.31.26.51a1.27,1.27,0,0,1-.61.58,3.29,3.29,0,0,1-.54.26,2.3,2.3,0,0,1-.45.14l-.38,0a1.55,1.55,0,0,1-.31,0l-.26,0a.29.29,0,0,0-.19.05l-.65.37c-.06,0-.1.08-.1.13s0,.09.1.13a2.77,2.77,0,0,0,.7.21,4.59,4.59,0,0,0,.92,0,5.66,5.66,0,0,0,1.06-.21,5.28,5.28,0,0,0,1.13-.5,3.22,3.22,0,0,0,.76-.58,1.4,1.4,0,0,0,.36-.61A.85.85,0,0,0,148.2,340.94Zm-25.43,13.6a3.17,3.17,0,0,0-1-.38,4.07,4.07,0,0,0-1.05-.08,4.63,4.63,0,0,0-1,.18,5.08,5.08,0,0,0-1,.42l-.34.22a1.3,1.3,0,0,0-.34.32l-1-.66,2.31-1.34a.15.15,0,0,0,.09-.13.14.14,0,0,0-.09-.12l-.58-.34a.4.4,0,0,0-.22-.05.41.41,0,0,0-.23.05l-3.09,1.78c-.06,0-.09.08-.09.13a.15.15,0,0,0,.09.13l2.54,1.75a.41.41,0,0,0,.23.05.4.4,0,0,0,.22-.05L119,356a.36.36,0,0,0,.16-.13l.07-.14a1,1,0,0,1,.15-.19,2,2,0,0,1,.36-.24,2.11,2.11,0,0,1,1-.29,1.6,1.6,0,0,1,.9.19c.3.17.43.36.41.57s-.19.4-.5.58c-.13.07-.25.14-.39.2a1.85,1.85,0,0,1-.4.12,2.12,2.12,0,0,1-.44,0,1.87,1.87,0,0,1-.46-.09.5.5,0,0,0-.24,0,.42.42,0,0,0-.2.05l-.66.39c-.07,0-.1.07-.1.12s0,.1.1.13a2.72,2.72,0,0,0,.76.27,3.42,3.42,0,0,0,.92.06,3.92,3.92,0,0,0,1-.18,4.84,4.84,0,0,0,1.11-.49,3.64,3.64,0,0,0,.73-.54,1.21,1.21,0,0,0,.33-.6.88.88,0,0,0-.16-.63A2.13,2.13,0,0,0,122.77,354.54ZM137,346.33a3.53,3.53,0,0,0-1-.37,4.14,4.14,0,0,0-1.05-.08,4.28,4.28,0,0,0-1,.18,4.46,4.46,0,0,0-1,.42l-.34.22a1.4,1.4,0,0,0-.33.31l-1-.66L133.6,345a.15.15,0,0,0,.09-.13c0-.05,0-.09-.09-.13l-.58-.33a.44.44,0,0,0-.23-.06.4.4,0,0,0-.22.06l-3.09,1.78c-.06,0-.09.08-.09.13s0,.09.09.13l2.54,1.75a.51.51,0,0,0,.44,0l.76-.44a.33.33,0,0,0,.15-.13s0-.09.08-.14a.77.77,0,0,1,.15-.19,1.71,1.71,0,0,1,.35-.24,2.18,2.18,0,0,1,1-.29,1.56,1.56,0,0,1,.91.19c.29.17.43.36.41.57s-.19.4-.5.58a3.49,3.49,0,0,1-.39.19,2,2,0,0,1-.41.13,1.53,1.53,0,0,1-.43,0,1.6,1.6,0,0,1-.47-.08.59.59,0,0,0-.23,0,.52.52,0,0,0-.2.06l-.67.38a.2.2,0,0,0-.1.13.14.14,0,0,0,.1.13,2.91,2.91,0,0,0,.77.27,3.42,3.42,0,0,0,.92.06,4.38,4.38,0,0,0,1-.18,5.31,5.31,0,0,0,1.11-.49,3.24,3.24,0,0,0,.72-.55,1.15,1.15,0,0,0,.34-.6.87.87,0,0,0-.16-.62A2.24,2.24,0,0,0,137,346.33Zm-14.36,4.1a.56.56,0,0,0-.23-.05.51.51,0,0,0-.22.05l-.64.37a.29.29,0,0,0-.11.11s0,.09,0,.14l-.38,1.84a.13.13,0,0,0,.07.14.33.33,0,0,0,.21.06l.86.06a.55.55,0,0,0,.24,0c.07,0,.11-.06.12-.12l.25-1.2,4.07,2.35a.51.51,0,0,0,.44,0l.67-.39a.14.14,0,0,0,.09-.12.15.15,0,0,0-.09-.13Zm-3.89,7.71a.44.44,0,0,0-.23-.06.4.4,0,0,0-.22.06L116,359.45l.13-1.68a1.53,1.53,0,0,0,0-.51.86.86,0,0,0-.13-.37.83.83,0,0,0-.25-.28,2,2,0,0,0-.37-.24,2.94,2.94,0,0,0-.76-.31,4.2,4.2,0,0,0-1-.13,4.34,4.34,0,0,0-1.06.11,3.66,3.66,0,0,0-1.06.42,2.17,2.17,0,0,0-.66.54,1.19,1.19,0,0,0-.25.6,1,1,0,0,0,.13.59,1.55,1.55,0,0,0,.51.51.4.4,0,0,0,.22.06.48.48,0,0,0,.22-.06l.66-.37a.22.22,0,0,0,.09-.12.17.17,0,0,0-.06-.15.81.81,0,0,1-.27-.5c0-.17.14-.34.44-.51a1.66,1.66,0,0,1,.92-.26,1.68,1.68,0,0,1,.78.21,1.22,1.22,0,0,1,.3.26.47.47,0,0,1,.09.41l-.33,2.64a.42.42,0,0,0,0,.16.35.35,0,0,0,.16.19l.51.29a.51.51,0,0,0,.44,0l3.84-2.22c.06,0,.09-.08.09-.13s0-.09-.09-.13Zm-6,2.44a2.7,2.7,0,0,0-.94-.33,4.21,4.21,0,0,0-1.07,0,.82.82,0,0,0-.14-.49,1.41,1.41,0,0,0-.49-.43,2.7,2.7,0,0,0-.85-.31,3.87,3.87,0,0,0-1-.06,4.3,4.3,0,0,0-1,.18,4.18,4.18,0,0,0-.94.41,3,3,0,0,0-.71.54,1.24,1.24,0,0,0-.31.57.84.84,0,0,0,.1.56,1.45,1.45,0,0,0,.54.49,2.88,2.88,0,0,0,1.6.37.79.79,0,0,0,0,.62,1.5,1.5,0,0,0,.59.54,2.56,2.56,0,0,0,.89.33,3.42,3.42,0,0,0,1,.06,4.75,4.75,0,0,0,1.08-.2,5.49,5.49,0,0,0,1.06-.46,3.29,3.29,0,0,0,.81-.62,1.34,1.34,0,0,0,.35-.63.78.78,0,0,0-.11-.59A1.52,1.52,0,0,0,112.68,360.58Zm-4.05.28a2.87,2.87,0,0,1-.4.18,2.09,2.09,0,0,1-.43.11,1.48,1.48,0,0,1-.42,0A1.09,1.09,0,0,1,107,361a.42.42,0,0,1-.21-.21.29.29,0,0,1,0-.24.59.59,0,0,1,.18-.25,1.56,1.56,0,0,1,.31-.23,2.43,2.43,0,0,1,.4-.18,2.26,2.26,0,0,1,.43-.11,1.48,1.48,0,0,1,.42,0,1.15,1.15,0,0,1,.37.12.4.4,0,0,1,.2.21.29.29,0,0,1,0,.24.72.72,0,0,1-.19.25A1.92,1.92,0,0,1,108.63,360.86Zm3.16.9a1.12,1.12,0,0,1-.23.29,1.87,1.87,0,0,1-.38.28,2.88,2.88,0,0,1-1,.35,1.62,1.62,0,0,1-.49,0,1,1,0,0,1-.43-.13.48.48,0,0,1-.24-.25.4.4,0,0,1,0-.28,1,1,0,0,1,.22-.3,2.44,2.44,0,0,1,.39-.28,3,3,0,0,1,.48-.22,3.18,3.18,0,0,1,.51-.13,2.1,2.1,0,0,1,.5,0,1,1,0,0,1,.42.13.48.48,0,0,1,.24.25A.42.42,0,0,1,111.79,361.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.6,350.81l1,.57a.4.4,0,0,0,.22.05.41.41,0,0,0,.23-.05l.66-.38c.06,0,.09-.08.09-.13a.15.15,0,0,0-.09-.13l-1-.57.7-.41c.06,0,.1-.08.09-.13s0-.09-.09-.13l-.58-.34a.51.51,0,0,0-.44,0l-.71.41-3.29-1.9a.51.51,0,0,0-.44,0l-.63.36a.28.28,0,0,0-.13.32l.35,1.8,2.59,1.5Zm-1-.6-1.41.81-.35-1.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.78,348.13a3.49,3.49,0,0,1-.39.19,2,2,0,0,1-.41.13,1.53,1.53,0,0,1-.43,0,1.6,1.6,0,0,1-.47-.08.59.59,0,0,0-.23,0,.52.52,0,0,0-.2.06l-.67.38a.2.2,0,0,0-.1.13.14.14,0,0,0,.1.13,2.91,2.91,0,0,0,.77.27,3.42,3.42,0,0,0,.92.06,4.38,4.38,0,0,0,1-.18,5.31,5.31,0,0,0,1.11-.49,3.24,3.24,0,0,0,.72-.55,1.15,1.15,0,0,0,.34-.6.87.87,0,0,0-.16-.62,2.24,2.24,0,0,0-.73-.62,3.53,3.53,0,0,0-1-.37,4.14,4.14,0,0,0-1.05-.08,4.28,4.28,0,0,0-1,.18,4.46,4.46,0,0,0-1,.42l-.34.22a1.4,1.4,0,0,0-.33.31l-1-.66L133.6,345a.15.15,0,0,0,.09-.13c0-.05,0-.09-.09-.13l-.58-.33a.44.44,0,0,0-.23-.06.4.4,0,0,0-.22.06l-3.09,1.78c-.06,0-.09.08-.09.13s0,.09.09.13l2.54,1.75a.51.51,0,0,0,.44,0l.76-.44a.33.33,0,0,0,.15-.13s0-.09.08-.14a.77.77,0,0,1,.15-.19,1.71,1.71,0,0,1,.35-.24,2.18,2.18,0,0,1,1-.29,1.56,1.56,0,0,1,.91.19c.29.17.43.36.41.57S136.09,348,135.78,348.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.8,346.34a4.74,4.74,0,0,0,1.12-.17,4.29,4.29,0,0,0,1.06-.43,2.83,2.83,0,0,0,.75-.61,1.2,1.2,0,0,0,.3-.65,1,1,0,0,0-.19-.63,2,2,0,0,0-.66-.58,3.42,3.42,0,0,0-1-.37,4.44,4.44,0,0,0-1.09-.11A4.74,4.74,0,0,0,139,343a4.8,4.8,0,0,0-1,.42l-.44-1.43a.06.06,0,0,0,0,0s0,0-.06-.05a.51.51,0,0,0-.44,0l-.74.43c-.08,0-.11.09-.11.13a.36.36,0,0,0,0,.11l.64,2.18a2.72,2.72,0,0,0,.26.58,1.79,1.79,0,0,0,.63.57,3.57,3.57,0,0,0,1,.38A4.51,4.51,0,0,0,139.8,346.34Zm-1.38-1.7c0-.23.18-.44.54-.65a2.38,2.38,0,0,1,1.11-.31,2,2,0,0,1,1,.24.68.68,0,0,1,.42.58c0,.22-.17.44-.53.64a2.18,2.18,0,0,1-1.12.31,2,2,0,0,1-1-.24C138.55,345.05,138.41,344.86,138.42,344.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.61,340.41a3,3,0,0,0-.76-.31,3.75,3.75,0,0,0-.82-.1,5,5,0,0,0-.86.1,4.49,4.49,0,0,0-.85.29l-.07-1.43a.71.71,0,0,0,0-.14.21.21,0,0,0-.11-.14l-.58-.33a.4.4,0,0,0-.22-.06.41.41,0,0,0-.23.06l-3.6,2.08a.14.14,0,0,0-.09.12.15.15,0,0,0,.09.13l.59.34a.48.48,0,0,0,.22.05.51.51,0,0,0,.22-.05l2.27-1.31.06,1.36a.81.81,0,0,0,0,.15.2.2,0,0,0,.11.13l.58.34a.52.52,0,0,0,.23.05.51.51,0,0,0,.22-.05l.68-.4a3.16,3.16,0,0,1,1-.37,1.15,1.15,0,0,1,.84.13c.25.14.33.31.26.51a1.27,1.27,0,0,1-.61.58,3.29,3.29,0,0,1-.54.26,2.3,2.3,0,0,1-.45.14l-.38,0a1.55,1.55,0,0,1-.31,0l-.26,0a.29.29,0,0,0-.19.05l-.65.37c-.06,0-.1.08-.1.13s0,.09.1.13a2.77,2.77,0,0,0,.7.21,4.59,4.59,0,0,0,.92,0,5.66,5.66,0,0,0,1.06-.21,5.28,5.28,0,0,0,1.13-.5,3.22,3.22,0,0,0,.76-.58,1.4,1.4,0,0,0,.36-.61.85.85,0,0,0-.1-.6A1.55,1.55,0,0,0,147.61,340.41Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-166"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416,364.9a1.07,1.07,0,0,0-.16-.27,1.77,1.77,0,0,0-.14-.17l-.15-.19-.18-.17a4.71,4.71,0,0,0-.66-.46L194.47,236.5a8.09,8.09,0,0,0-7.3,0l-108,62.33c-.16.1-.31.18-.43.27l-.15.12a2.78,2.78,0,0,0-.61.69.78.78,0,0,0-.11.18,1.08,1.08,0,0,0-.11.28,1.8,1.8,0,0,0-.06.22,1.55,1.55,0,0,0,0,.37,2,2,0,0,0,0,.25,1.57,1.57,0,0,0,.08.29,2.18,2.18,0,0,0,.11.27,3.18,3.18,0,0,0,1.3,1.27L299.42,430.18a6.7,6.7,0,0,0,2.17.74,10.31,10.31,0,0,0,1.48.12,10.17,10.17,0,0,0,1.47-.11,2.46,2.46,0,0,0,.47-.1,6.4,6.4,0,0,0,1.32-.44c.14-.06.26-.14.39-.21l108-62.33C416.07,367.05,416.5,365.91,416,364.9Zm-23.71-4.52-6.91,4-92,53.07c-.25.13-.49.26-.74.37a6.27,6.27,0,0,1-4.74,0c-.25-.11-.51-.24-.75-.37L112.49,316.6,104,311.73a3.24,3.24,0,0,1-.79-.62c-.88-1-.6-2.18.79-3l98.85-57.06a6.27,6.27,0,0,1,3.84-1.07,4.09,4.09,0,0,1,.94.25,3.07,3.07,0,0,1,.48.24L392.26,356.76A2.09,2.09,0,0,1,392.26,360.38Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,364.9a1.07,1.07,0,0,0-.16-.27,1.77,1.77,0,0,0-.14-.17l-.15-.19-.18-.17a4.71,4.71,0,0,0-.66-.46L194.47,236.5a8.09,8.09,0,0,0-7.3,0l-108,62.33c-.16.1-.31.18-.43.27l-.15.12a2.78,2.78,0,0,0-.61.69.78.78,0,0,0-.11.18,1.08,1.08,0,0,0-.11.28,1.8,1.8,0,0,0-.06.22,1.55,1.55,0,0,0,0,.37,2,2,0,0,0,0,.25,1.57,1.57,0,0,0,.08.29,2.18,2.18,0,0,0,.11.27,3.18,3.18,0,0,0,1.3,1.27L299.42,430.18a6.7,6.7,0,0,0,2.17.74,10.31,10.31,0,0,0,1.48.12,10.17,10.17,0,0,0,1.47-.11,2.46,2.46,0,0,0,.47-.1,6.4,6.4,0,0,0,1.32-.44c.14-.06.26-.14.39-.21l108-62.33C416.07,367.05,416.5,365.91,416,364.9Zm-23.71-4.52-6.91,4-92,53.07c-.25.13-.49.26-.74.37a6.27,6.27,0,0,1-4.74,0c-.25-.11-.51-.24-.75-.37L112.49,316.6,104,311.73a3.24,3.24,0,0,1-.79-.62c-.88-1-.6-2.18.79-3l98.85-57.06a6.27,6.27,0,0,1,3.84-1.07,4.09,4.09,0,0,1,.94.25,3.07,3.07,0,0,1,.48.24L392.26,356.76A2.09,2.09,0,0,1,392.26,360.38Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.78,299.11a8.17,8.17,0,0,0-3.23,6V310a8.08,8.08,0,0,0,3.65,6.33L299.4,443.44a7,7,0,0,0,2.68.82,7.77,7.77,0,0,0,1,.06h0V431.05h0a9,9,0,0,1-1.48-.12,6.47,6.47,0,0,1-2.17-.74L79.21,303C77.35,302,77.2,300.27,78.78,299.11Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.78,299.11a8.17,8.17,0,0,0-3.23,6V310a8.08,8.08,0,0,0,3.65,6.33L299.4,443.44a7,7,0,0,0,2.68.82,7.77,7.77,0,0,0,1,.06h0V431.05h0a9,9,0,0,1-1.48-.12,6.47,6.47,0,0,1-2.17-.74L79.21,303C77.35,302,77.2,300.27,78.78,299.11Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.65,390.78a14.7,14.7,0,0,0-13,0,5.26,5.26,0,0,0-1.95,1.78c-1.17,2,1,3.56,1.95,4.13a14.7,14.7,0,0,0,13,0,5.51,5.51,0,0,0,2-1.78C360.77,392.88,358.62,391.35,357.65,390.78Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,273.38a1.09,1.09,0,0,0,0-2.06,3.94,3.94,0,0,0-3.57,0,1.09,1.09,0,0,0,0,2.06A3.94,3.94,0,0,0,142,273.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.42,283.14a1,1,0,0,0,0-1.83,3.54,3.54,0,0,0-3.17,0,1,1,0,0,0,0,1.83A3.48,3.48,0,0,0,136.42,283.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.78,280.12l17.72-10.24c1-.56,1-1.44.11-2a3.76,3.76,0,0,0-3.41.06l-17.72,10.23c-1,.56-1,1.45-.11,2A3.76,3.76,0,0,0,141.78,280.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.16,364c1.52,1.18,1.35,2.84-.48,3.89l-108,62.34a7.49,7.49,0,0,1-3.65.86v13.27a7.43,7.43,0,0,0,3.64-.89l108-62.31a8,8,0,0,0,3.65-6.33l0-4.83A8.17,8.17,0,0,0,415.16,364Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.16,364c1.52,1.18,1.35,2.84-.48,3.89l-108,62.34a7.49,7.49,0,0,1-3.65.86v13.27a7.43,7.43,0,0,0,3.64-.89l108-62.31a8,8,0,0,0,3.65-6.33l0-4.83A8.17,8.17,0,0,0,415.16,364Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mobile--inject-166"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.71,336.5a4,4,0,0,1,1.88,3.13,1.15,1.15,0,0,1-.52,1.1l-1.32.77a1.39,1.39,0,0,1-1.36-.16l-24.55-14.17A4,4,0,0,1,103,324a1.23,1.23,0,0,1,.48-1.08c.24-.15,1.13-.66,1.36-.79a1.4,1.4,0,0,1,1.37.15Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.71,336.5a4,4,0,0,1,1.88,3.13,1.15,1.15,0,0,1-.52,1.1l-1.32.77a1.39,1.39,0,0,1-1.36-.16l-24.55-14.17A4,4,0,0,1,103,324a1.23,1.23,0,0,1,.48-1.08c.24-.15,1.13-.66,1.36-.79a1.4,1.4,0,0,1,1.37.15Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.39,337.26l-24.55-14.18c-1-.6-1.89-.17-1.89,1a4,4,0,0,0,1.89,3.13l24.55,14.17c1,.61,1.89.18,1.89-.95A4,4,0,0,0,129.39,337.26Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.39,337.26l-24.55-14.18c-1-.6-1.89-.17-1.89,1a4,4,0,0,0,1.89,3.13l24.55,14.17c1,.61,1.89.18,1.89-.95A4,4,0,0,0,129.39,337.26Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.85,317.52a4.05,4.05,0,0,1,1.88,3.14,1.16,1.16,0,0,1-.52,1.1l-1.32.77a1.39,1.39,0,0,1-1.36-.16L85,315.69a4,4,0,0,1-1.89-3.13,1.2,1.2,0,0,1,.48-1.08c.23-.15,1.12-.66,1.36-.79a1.35,1.35,0,0,1,1.36.15Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.85,317.52a4.05,4.05,0,0,1,1.88,3.14,1.16,1.16,0,0,1-.52,1.1l-1.32.77a1.39,1.39,0,0,1-1.36-.16L85,315.69a4,4,0,0,1-1.89-3.13,1.2,1.2,0,0,1,.48-1.08c.23-.15,1.12-.66,1.36-.79a1.35,1.35,0,0,1,1.36.15Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.53,318.28,85,311.6c-1-.6-1.89-.17-1.89,1A4,4,0,0,0,85,315.69l11.57,6.68c1,.6,1.89.18,1.89-.95A4.06,4.06,0,0,0,96.53,318.28Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.53,318.28,85,311.6c-1-.6-1.89-.17-1.89,1A4,4,0,0,0,85,315.69l11.57,6.68c1,.6,1.89.18,1.89-.95A4.06,4.06,0,0,0,96.53,318.28Z",
    style: {
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M392.26,360.38l-6.91,4-177-102.15c-1.72-1-3.53-.41-5.25.58L111.2,315.88,104,311.72a3.22,3.22,0,0,1-.79-.61c-.88-1-.6-2.18.79-3l98.85-57.06a6.27,6.27,0,0,1,3.84-1.07,3.28,3.28,0,0,1,.94.25,3.07,3.07,0,0,1,.48.24L392.26,356.76A2.09,2.09,0,0,1,392.26,360.38Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.26,360.38l-6.91,4-177-102.15c-1.72-1-3.53-.41-5.25.58L111.2,315.88,104,311.72a3.22,3.22,0,0,1-.79-.61c-.88-1-.6-2.18.79-3l98.85-57.06a6.27,6.27,0,0,1,3.84-1.07,3.28,3.28,0,0,1,.94.25,3.07,3.07,0,0,1,.48.24L392.26,356.76A2.09,2.09,0,0,1,392.26,360.38Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.1,250a7,7,0,0,0-3.21,1.09L104,308.11c-1.39.82-1.67,2-.79,3a3.22,3.22,0,0,0,.79.61l7.16,4.16,91.94-53.08a7.62,7.62,0,0,1,3-1.06Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.1,250a7,7,0,0,0-3.21,1.09L104,308.11c-1.39.82-1.67,2-.79,3a3.22,3.22,0,0,0,.79.61l7.16,4.16,91.94-53.08a7.62,7.62,0,0,1,3-1.06Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-166"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.26,360.33l-6.91,4-92,53.07c-.25.13-.49.26-.74.36a6.18,6.18,0,0,1-4.74,0,7.36,7.36,0,0,1-.75-.36L112.49,316.55,104,311.68a3.24,3.24,0,0,1-.79-.62c-.88-1-.6-2.19.79-3L202.89,251a6.33,6.33,0,0,1,3.84-1.06,3.64,3.64,0,0,1,.94.25,3,3,0,0,1,.48.23l184.11,106.3A2.09,2.09,0,0,1,392.26,360.33Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.92,304.21a.33.33,0,0,1-.15,0l-.48-.28-1.17.68a.21.21,0,0,1-.2,0l-.17-.1a.18.18,0,0,1-.08-.06s0,0,0-.06l-.5-1.73s0-.05,0-.07l.06,0,.17-.1a.23.23,0,0,1,.14,0,.44.44,0,0,1,.15.05l1.7,1,.26-.15a.25.25,0,0,1,.14,0,.48.48,0,0,1,.14.05l.12.07s.08.06.08.08,0,.05-.07.08l-.26.15.49.28s.08.06.08.08,0,.06-.08.09l-.19.11A.27.27,0,0,1,124.92,304.21Zm-1-.61-1.21-.7.37,1.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,303.24a3.14,3.14,0,0,1-1.46-.45c-.48-.28-.74-.56-.77-.85s.15-.54.57-.78a2.53,2.53,0,0,1,.53-.24,2.09,2.09,0,0,1,.53-.11h.09l0,0,.11.19s0,0,0,.05h-.06a2,2,0,0,0-.76.25q-.42.24-.39.54c0,.2.22.41.59.62a2.4,2.4,0,0,0,1.07.35,1.72,1.72,0,0,0,.91-.21,2,2,0,0,0,.26-.18.7.7,0,0,0,.15-.18l-.79-.46-.48.28a.2.2,0,0,1-.14,0,.3.3,0,0,1-.15-.05l-.11-.06s-.08-.06-.08-.08,0-.05.07-.08l.77-.45a.27.27,0,0,1,.17,0,.32.32,0,0,1,.17.06l1.12.65a.23.23,0,0,1,.09.06.06.06,0,0,1,0,.06,1.31,1.31,0,0,1-.68.67A2.4,2.4,0,0,1,126,303.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.68,297.45c.38.21.38.56,0,.78a1.46,1.46,0,0,1-1.35,0c-.38-.22-.38-.57,0-.78A1.46,1.46,0,0,1,135.68,297.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.22,296.81c-.69.39-.9,1-.64,1.45a.46.46,0,0,0,.41.16h0c.22,0,.38-.15.31-.28-.19-.35,0-.75.44-1a2.8,2.8,0,0,1,1.78-.25c.22,0,.45-.05.48-.18h0c0-.11-.09-.21-.27-.24A3.9,3.9,0,0,0,133.22,296.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.13,296.18c-1,.59-1.38,1.41-1.09,2.17,0,.11.22.18.41.17h0c.22,0,.37-.14.32-.26-.24-.62.05-1.29.88-1.77a5.15,5.15,0,0,1,3.07-.52c.22,0,.43-.05.46-.18h0c0-.11-.11-.22-.3-.24A6.22,6.22,0,0,0,132.13,296.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.13,286.5a.18.18,0,0,1-.11,0,.09.09,0,0,1,0-.08l.21-1a.64.64,0,0,1,0-.07.13.13,0,0,1,.06-.07l.35-.2a.25.25,0,0,1,.24,0l2.9,1.68a.07.07,0,0,1,.05.06.08.08,0,0,1-.05.07l-.36.21a.24.24,0,0,1-.12,0,.21.21,0,0,1-.12,0l-2.22-1.27-.14.65a.13.13,0,0,1-.06.07l-.13,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.4,285.19a.18.18,0,0,1-.11,0,.1.1,0,0,1,0-.08l.21-1s0-.05,0-.08a.17.17,0,0,1,.06-.06l.35-.2a.25.25,0,0,1,.24,0l2.9,1.67a.08.08,0,0,1,.05.07s0,0-.05.07l-.36.21a.26.26,0,0,1-.24,0l-2.22-1.28-.14.66a.09.09,0,0,1-.06.06.19.19,0,0,1-.13,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.26,283.4a.21.21,0,0,1,.12,0,.24.24,0,0,1,.12,0l.44.26a.07.07,0,0,1,.05.06.1.1,0,0,1-.05.08l-.42.24-.12,0-.12,0-.44-.26s-.05,0-.05-.07,0,0,.05-.07Zm1.57.91a.25.25,0,0,1,.24,0l.44.25s.05,0,.05.07,0,.05-.05.07l-.42.24a.26.26,0,0,1-.24,0l-.44-.25s0,0,0-.07,0-.05,0-.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.91,283.32a.28.28,0,0,1-.13,0l-.12,0-.54-.32-1.39.81a.24.24,0,0,1-.12,0,.21.21,0,0,1-.12,0l-.32-.19a.15.15,0,0,1-.08-.08.16.16,0,0,1,0-.09l-.35-1.79a.15.15,0,0,1,.08-.17l.34-.2.12,0,.12,0,1.79,1,.39-.22a.25.25,0,0,1,.24,0l.32.18s0,0,0,.07,0,.05,0,.07l-.39.22.55.32s0,0,0,.07,0,0,0,.07Zm-1.35-.64-1-.55.19,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.69,280.53s-.05,0-.05-.07a.1.1,0,0,1,.05-.07l1.69-1a.21.21,0,0,1,.12,0,.27.27,0,0,1,.12,0l.32.18a.1.1,0,0,1,.05.07s0,.05-.05.07l-1.26.73.52.36a1,1,0,0,1,.18-.17l.19-.12a2.5,2.5,0,0,1,.53-.23,2.28,2.28,0,0,1,.57-.1,2.24,2.24,0,0,1,.58.05,1.7,1.7,0,0,1,.53.2,1.08,1.08,0,0,1,.4.34.47.47,0,0,1,.08.34.5.5,0,0,1-.18.32,1.54,1.54,0,0,1-.39.3,2.92,2.92,0,0,1-.61.27,2.28,2.28,0,0,1-.56.1,1.61,1.61,0,0,1-.5,0,1.59,1.59,0,0,1-.42-.14s-.06,0,0-.07,0-.05,0-.07l.36-.21a.2.2,0,0,1,.11,0h.13a.79.79,0,0,0,.25.05.62.62,0,0,0,.24,0,.79.79,0,0,0,.22-.06l.22-.11c.17-.1.26-.2.27-.32s-.06-.22-.23-.31a.85.85,0,0,0-.49-.1,1.33,1.33,0,0,0-.55.15.92.92,0,0,0-.19.14.31.31,0,0,0-.08.1.56.56,0,0,1-.05.08.19.19,0,0,1-.08.07l-.41.24-.12,0a.28.28,0,0,1-.13,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.37 311.87 111.43 311.33 112.68 310.61 113.61 311.15 112.37 311.87",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.24 310.79 112.37 309.71 113.61 308.99 115.48 310.07 114.24 310.79",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.11 309.71 113.3 308.09 114.55 307.37 117.36 308.99 116.11 309.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.98 308.63 114.24 306.47 115.49 305.75 119.23 307.91 117.98 308.63",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.54,256.31a1.26,1.26,0,0,0-.74.11l-4.66,2.68c-.3.18-.22.49.18.73l1.7,1a2,2,0,0,0,.82.24,1.51,1.51,0,0,0,.37,0,.86.86,0,0,0,.36-.1l4.67-2.69c.3-.17.22-.49-.18-.72l-1.7-1A2.07,2.07,0,0,0,202.54,256.31Zm-2.74,4.57a1.09,1.09,0,0,1-.36-.12l-1.7-1c-.29-.17-.35-.43-.13-.55l4.66-2.69a.6.6,0,0,1,.19-.06h.12a1,1,0,0,1,.35.11l1.7,1c.3.17.36.42.14.55l-4.67,2.68A.58.58,0,0,1,199.8,260.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.79,258.89l2,1.16-.73.42a.37.37,0,0,1-.25,0l-1.5-.86c-.21-.13-.26-.32-.1-.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.13 258.69 200 258.19 202.02 259.35 201.14 259.85 199.13 258.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.35 257.99 201.22 257.49 203.24 258.65 202.36 259.15 200.35 257.99",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.57,256.86l1.45.84c.27.16.21.38-.15.59l-.29.17-2-1.17.69-.4A.49.49,0,0,1,202.57,256.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.54,256.45a1.29,1.29,0,0,1,.87.23l.31.18c.35.2.54.43.41.51l-.22.15-1.6-.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.66 264.15 194.28 261.01 196.18 263.72 193.68 263.04 190.66 264.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.55,316.53a.52.52,0,0,1-.45-.26.52.52,0,0,1,.19-.72l8.57-4.95a.53.53,0,1,1,.53.91l-8.57,4.95A.54.54,0,0,1,121.55,316.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.49,318.19a.52.52,0,0,1-.26-1l8.57-4.95a.53.53,0,1,1,.52.92l-8.57,4.94A.48.48,0,0,1,124.49,318.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.43,319.86a.53.53,0,0,1-.27-1l8.57-4.94a.53.53,0,0,1,.53.91l-8.57,5A.51.51,0,0,1,127.43,319.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.32,301.79l-.26-.15c-1.76-1-1.76-2.67,0-3.69L180,281.85a7.05,7.05,0,0,1,6.39,0l.26.14c1.76,1,1.76,2.68,0,3.7l-27.89,16.09A7.09,7.09,0,0,1,152.32,301.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,267.25a4.19,4.19,0,0,0-3.78,0,1.16,1.16,0,0,0,0,2.19,4.19,4.19,0,0,0,3.78,0A1.16,1.16,0,0,0,205,267.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.79,269.35,204.87,271a1.34,1.34,0,0,0,0,2.53l1.24.72,7.3-4.21-1.25-.72A4.81,4.81,0,0,0,207.79,269.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,270.58l.42-.24-1.18-.68c-1.13-.85-1-2.06.3-2.84a5.9,5.9,0,0,1,4.9-.17l1.19.68.14-.08a.77.77,0,0,1,.31,1.09.36.36,0,0,0-.3.13l-.18.31c-.07.12,0,.24.24.28h0a.48.48,0,0,0,.48-.15l.18-.31c.05-.09,0-.17-.13-.22a.91.91,0,0,0-.39-1.27l0,0a.21.21,0,0,0,0-.39l-1-.59a.76.76,0,0,0-.66,0l-.06,0a6.9,6.9,0,0,0-5.22.41c-1.41.81-1.63,2.05-.71,3l-.06,0a.21.21,0,0,0,0,.39l1,.59A.7.7,0,0,0,201,270.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.8,345.1a1,1,0,0,1-.5-.14l-8.5-4.91a3.64,3.64,0,0,1,0-6.77l8.5-4.91a1,1,0,0,1,1.37.37,1,1,0,0,1-.36,1.37l-8.5,4.91c-.83.48-1.3,1.08-1.3,1.65s.47,1.16,1.3,1.64l8.5,4.91a1,1,0,0,1-.51,1.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.07,380.74a9.88,9.88,0,0,1-4.86-1.18l-8.49-4.9a1,1,0,1,1,1-1.75l8.49,4.91a8.68,8.68,0,0,0,7.7,0l8.51-4.91a1,1,0,0,1,1.37.36,1,1,0,0,1-.36,1.38l-8.51,4.91A9.85,9.85,0,0,1,243.07,380.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.35,345.1a1,1,0,0,1-.5-1.88l8.49-4.9c.83-.48,1.3-1.08,1.3-1.65s-.47-1.16-1.3-1.64l-8.49-4.91a1,1,0,0,1,1-1.74l8.5,4.91a3.64,3.64,0,0,1,0,6.77l-8.5,4.9A1,1,0,0,1,307.35,345.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.93,300.54a1,1,0,0,1-.5-.14l-8.51-4.92a8.65,8.65,0,0,0-7.7,0l-8.49,4.9a1,1,0,1,1-1-1.74l8.49-4.91a10.62,10.62,0,0,1,9.72,0l8.51,4.92a1,1,0,0,1,.36,1.37A1,1,0,0,1,255.93,300.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Button--inject-166"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.35,403.39l-8.28-4.79c-1.26-.72-1.26-1.9,0-2.63l72.56-41.9a5.1,5.1,0,0,1,4.57,0l8.28,4.79a1.39,1.39,0,0,1,0,2.64l-72.56,41.89A5,5,0,0,1,279.35,403.39Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.35,402.15l-8.28-4.78a1.39,1.39,0,0,1,0-2.64l72.56-41.89a5,5,0,0,1,4.57,0l8.28,4.78a1.39,1.39,0,0,1,0,2.64l-72.56,41.89A5,5,0,0,1,279.35,402.15Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.78,393.57l-12.86-7.42-14.85,8.58a1.39,1.39,0,0,0,0,2.64l8.28,4.78a5,5,0,0,0,4.57,0Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.54,396.86h-.28a.54.54,0,0,1-.27-.06l-.62-.35a.12.12,0,0,1-.06-.09.1.1,0,0,1,.06-.09l0,0h.07l4.48-.35a1.57,1.57,0,0,1,.29,0,.55.55,0,0,1,.23.07l.3.18a.23.23,0,0,1,.13.13.61.61,0,0,1,0,.17l-.67,2.55,0,0a0,0,0,0,1,0,0,.29.29,0,0,1-.16,0,.26.26,0,0,1-.15,0l-.62-.35a.18.18,0,0,1-.1-.16.41.41,0,0,1,0-.16l.37-1.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.17,394.77h-.28a.54.54,0,0,1-.27-.06l-.62-.36a.1.1,0,0,1-.06-.09.12.12,0,0,1,.06-.09h0l.06,0,4.49-.35a1.48,1.48,0,0,1,.29,0,.43.43,0,0,1,.23.07l.3.17c.08.05.12.09.12.14a.32.32,0,0,1,0,.16l-.67,2.56,0,0,0,0a.3.3,0,0,1-.3,0l-.62-.36a.18.18,0,0,1-.11-.15.47.47,0,0,1,0-.17l.37-1.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.8,392.67h-.28a.54.54,0,0,1-.27-.06l-.62-.35a.12.12,0,0,1-.06-.09.1.1,0,0,1,.06-.09l0,0h.06l4.49-.35a1.47,1.47,0,0,1,.28,0,.55.55,0,0,1,.24.07l.3.18c.08,0,.12.09.12.13a.28.28,0,0,1,0,.17l-.66,2.55,0,0,0,0a.3.3,0,0,1-.3,0l-.62-.35a.21.21,0,0,1-.11-.16.78.78,0,0,1,0-.16l.38-1.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.75,382.17a4.38,4.38,0,0,1,1-.44,4.72,4.72,0,0,1,1-.18,3.24,3.24,0,0,1,.84,0,2.18,2.18,0,0,1,.62.18.14.14,0,0,1,.09.12.17.17,0,0,1-.1.12l-.53.31a.57.57,0,0,1-.24.08,1.09,1.09,0,0,1-.25,0,2.6,2.6,0,0,0-.68,0,2.31,2.31,0,0,0-.82.32,1.28,1.28,0,0,0-.34.24.83.83,0,0,0-.19.25.31.31,0,0,0,0,.23.33.33,0,0,0,.18.19,1,1,0,0,0,.35.13,1.41,1.41,0,0,0,.44,0,4.06,4.06,0,0,0,.6-.17l.86-.31a7.79,7.79,0,0,1,1-.32,3.91,3.91,0,0,1,.85-.13,2.48,2.48,0,0,1,.74.07,2.33,2.33,0,0,1,.66.26,1.17,1.17,0,0,1,.48.45.68.68,0,0,1,.07.54,1.31,1.31,0,0,1-.36.59,3.14,3.14,0,0,1-.8.6,4.43,4.43,0,0,1-.91.41,5.14,5.14,0,0,1-1,.23,4.42,4.42,0,0,1-1,0,2.55,2.55,0,0,1-.81-.23q-.09-.06-.09-.12a.18.18,0,0,1,.09-.12l.53-.31a.69.69,0,0,1,.25-.09,1.14,1.14,0,0,1,.25,0l.32,0a1.64,1.64,0,0,0,.38,0,2.93,2.93,0,0,0,.45-.11,3.52,3.52,0,0,0,.53-.25,2.67,2.67,0,0,0,.41-.28,1,1,0,0,0,.26-.28.43.43,0,0,0,.06-.26c0-.09-.08-.16-.19-.23a.83.83,0,0,0-.38-.1,1.77,1.77,0,0,0-.51.09c-.19.05-.42.13-.68.22l-.91.33a7.5,7.5,0,0,1-.88.25,3.15,3.15,0,0,1-.78.1,2.76,2.76,0,0,1-.71-.09,2.62,2.62,0,0,1-.68-.29,1.24,1.24,0,0,1-.48-.45.73.73,0,0,1-.07-.52,1.22,1.22,0,0,1,.31-.56A2.75,2.75,0,0,1,299.75,382.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,382.8a.12.12,0,0,1,.08.12.14.14,0,0,1-.08.12l-.58.33a.39.39,0,0,1-.2.05.46.46,0,0,1-.21-.05l-5-2.88c-.06,0-.09-.07-.08-.12s0-.08.08-.11l.58-.34a.39.39,0,0,1,.2-.05.46.46,0,0,1,.21.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.79,378.68a.39.39,0,0,1,.2-.05.46.46,0,0,1,.21.05l.59.34a.13.13,0,0,1,0,.24l-.66.38a.4.4,0,0,1-.2,0,.46.46,0,0,1-.21,0l-.59-.35a.12.12,0,0,1,0-.23Zm5.35,2.9a.15.15,0,0,1,.09.12.17.17,0,0,1-.09.12l-.58.33a.39.39,0,0,1-.2.05.46.46,0,0,1-.21-.05l-3.54-2a.17.17,0,0,1-.08-.12.14.14,0,0,1,.08-.12l.58-.33a.35.35,0,0,1,.21-.05.31.31,0,0,1,.2.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,377.85a2.81,2.81,0,0,1,.47-.22l.44-.12.39-.06h.31l-1.62-.94a.12.12,0,0,1-.08-.12s0-.08.08-.11l.58-.34a.4.4,0,0,1,.2,0,.46.46,0,0,1,.21,0l5,2.88a.13.13,0,0,1,0,.24l-.58.33a.39.39,0,0,1-.2.05.46.46,0,0,1-.21-.05l-.17-.1a1.21,1.21,0,0,1,0,.18,1.28,1.28,0,0,1-.09.22,1.22,1.22,0,0,1-.22.26,2.55,2.55,0,0,1-.37.27,2.91,2.91,0,0,1-.84.31,4.24,4.24,0,0,1-1.83-.06,3.69,3.69,0,0,1-.81-.31l-.28-.15-.25-.15a2,2,0,0,1-.54-.47,1.1,1.1,0,0,1-.22-.53.8.8,0,0,1,.13-.53A1.32,1.32,0,0,1,310,377.85Zm1.14,1.47a2.1,2.1,0,0,0,.42.24,2.23,2.23,0,0,0,1,.24,2,2,0,0,0,.84-.24c.25-.15.39-.31.41-.49s-.09-.36-.34-.53l-.27-.18-.31-.16A1.89,1.89,0,0,0,312,378a1.86,1.86,0,0,0-.86.23.73.73,0,0,0-.41.49C310.66,378.91,310.8,379.11,311.1,379.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.08,377.26a2.55,2.55,0,0,1-.68-.53,1.22,1.22,0,0,1-.28-.6.93.93,0,0,1,.15-.59,1.88,1.88,0,0,1,.62-.54,3.19,3.19,0,0,1,.92-.35,4.33,4.33,0,0,1,1-.1,4.08,4.08,0,0,1,1,.14,3.3,3.3,0,0,1,.88.35l.34.2a.12.12,0,0,1,0,.23l-2.54,1.47a1.24,1.24,0,0,0,.38.14,2,2,0,0,0,.42,0,1.89,1.89,0,0,0,.79-.24,1.34,1.34,0,0,0,.34-.26.57.57,0,0,0,.13-.22.33.33,0,0,1,.05-.12.32.32,0,0,1,.12-.1l.61-.35a.46.46,0,0,1,.21-.05.31.31,0,0,1,.2.05.42.42,0,0,1,.16.22.62.62,0,0,1,0,.38,1.21,1.21,0,0,1-.27.47,2.13,2.13,0,0,1-.63.5,2.94,2.94,0,0,1-.92.36,3.81,3.81,0,0,1-1,.1,4.42,4.42,0,0,1-1-.16A4.09,4.09,0,0,1,315.08,377.26Zm.72-1.73a.94.94,0,0,0-.31.26.42.42,0,0,0-.1.24.39.39,0,0,0,.07.23.69.69,0,0,0,.16.18l1.72-1a1.6,1.6,0,0,0-.29-.11,1.5,1.5,0,0,0-.37,0,1.6,1.6,0,0,0-.42,0A1.73,1.73,0,0,0,315.8,375.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.25,373.18a1,1,0,0,0,.5.14,1.1,1.1,0,0,0,.6-.18l.47-.27a.39.39,0,0,1,.2-.05.46.46,0,0,1,.21.05l.5.29a.14.14,0,0,1,.08.12.17.17,0,0,1-.08.12l-.56.32a3.07,3.07,0,0,1-1.45.43,2.61,2.61,0,0,1-1.44-.39l-1.63-.94-.51.29a.39.39,0,0,1-.2.05.46.46,0,0,1-.21-.05l-.5-.29a.14.14,0,0,1-.08-.12.17.17,0,0,1,.08-.12l.5-.29-1.23-.71a.12.12,0,0,1,0-.24l.57-.33a.46.46,0,0,1,.21-.05.39.39,0,0,1,.2.05l1.24.71,1-.56a.46.46,0,0,1,.21-.05.39.39,0,0,1,.2.05l.5.29a.14.14,0,0,1,.09.12s0,.08-.09.12l-1,.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.47,369.47a3.54,3.54,0,0,1,.88-.36,4.35,4.35,0,0,1,.95-.13,4,4,0,0,1,.92.08,3.12,3.12,0,0,1,.83.28l.18.09.21.13.21.12.16.1a1.56,1.56,0,0,1,.48.48.87.87,0,0,1,.14.53,1.06,1.06,0,0,1-.23.54,2.12,2.12,0,0,1-.63.51,3.54,3.54,0,0,1-.88.36,4.45,4.45,0,0,1-.94.14,4,4,0,0,1-.92-.08A3.12,3.12,0,0,1,325,372l-.18-.09-.22-.12-.21-.12-.16-.11a1.37,1.37,0,0,1-.48-.48.94.94,0,0,1-.14-.53,1.09,1.09,0,0,1,.23-.55A2.28,2.28,0,0,1,324.47,369.47Zm2.63.46a1.8,1.8,0,0,0-.5-.16,1.51,1.51,0,0,0-.47,0,1.24,1.24,0,0,0-.4.09,2.29,2.29,0,0,0-.35.16,1.55,1.55,0,0,0-.28.2.46.46,0,0,0-.15.23.32.32,0,0,0,0,.27.75.75,0,0,0,.28.29l.14.1.18.11.2.11.16.08a2.07,2.07,0,0,0,.5.16,2.5,2.5,0,0,0,.47,0,2.35,2.35,0,0,0,.4-.09l.35-.16a2.26,2.26,0,0,0,.28-.2.57.57,0,0,0,.15-.24.33.33,0,0,0,0-.27.93.93,0,0,0-.28-.29l-.14-.09-.19-.11-.19-.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.15,364.7a4.1,4.1,0,0,1,1.86-.57,3.2,3.2,0,0,1,1.78.43c.56.33.81.67.77,1s-.38.72-1,1.08l-1.22.7,1.7,1a.12.12,0,0,1,0,.23l-.62.36a.39.39,0,0,1-.2.05A.43.43,0,0,1,333,369l-4.91-2.84a.12.12,0,0,1,0-.23Zm1.25,2.13,1.18-.68a1.09,1.09,0,0,0,.52-.5c.06-.16-.05-.33-.34-.49a1.24,1.24,0,0,0-.84-.19,2.11,2.11,0,0,0-.86.3l-1.18.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.18,364.5a.72.72,0,0,1-.2-.28.6.6,0,0,1,0-.38,1,1,0,0,1,.23-.43,2,2,0,0,1,.58-.45,3.35,3.35,0,0,1,.8-.35,2.93,2.93,0,0,1,.83-.13,3,3,0,0,1,.85.08,3.14,3.14,0,0,1,.81.33l2.23,1.29a.12.12,0,0,1,.08.12.14.14,0,0,1-.08.12l-.58.33a.39.39,0,0,1-.2.05.46.46,0,0,1-.21-.05l-.25-.15a.69.69,0,0,1-.08.49,1.66,1.66,0,0,1-.61.53,3,3,0,0,1-.67.28,2.66,2.66,0,0,1-1.33.05,2.18,2.18,0,0,1-.57-.22q-.52-.3-.45-.69a1.57,1.57,0,0,1,.6-.8l1-.84a1,1,0,0,0-.64-.14,1.63,1.63,0,0,0-.64.22.65.65,0,0,0-.24.2.48.48,0,0,0-.07.21.16.16,0,0,1,0,.12.21.21,0,0,1-.1.08l-.71.41a.34.34,0,0,1-.17.05A.25.25,0,0,1,335.18,364.5Zm3.41.5a1.65,1.65,0,0,0,.39-.3.65.65,0,0,0,.14-.31.41.41,0,0,0-.07-.28.74.74,0,0,0-.24-.22l-.07,0-.86.7a.8.8,0,0,0-.29.35c0,.09,0,.17.14.24a.58.58,0,0,0,.4,0A1.38,1.38,0,0,0,338.59,365Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.45,362.92l-5-1.14-.06,0a.12.12,0,0,1-.08-.11.12.12,0,0,1,.08-.12l.57-.33a.38.38,0,0,1,.22-.06.62.62,0,0,1,.21,0l3.36.77L341.42,360a.21.21,0,0,1,0-.12.2.2,0,0,1,.1-.13l.57-.33a.46.46,0,0,1,.21,0,.39.39,0,0,1,.2,0l0,0,2.82,4.09a.21.21,0,0,1,0,.12.2.2,0,0,1-.1.13l-.57.33a.46.46,0,0,1-.21.05.42.42,0,0,1-.2-.05.1.1,0,0,1-.05,0Z",
    style: {
      fill: "#455a64"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Card--inject-166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--card--inject-166"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.21,129.17v93.62A3.8,3.8,0,0,0,65,226.36c1.07.64,5,2.9,5,2.9s-1.6-3.43-1.6-3.47l0-70.91V132.15a11.75,11.75,0,0,1,5.34-9.24L196.53,52s3.14-.6,3.18-.62-3.61-2.21-4.87-2.87c-.9-.49-2.17-.27-3.51.49L68.55,119.93A11.74,11.74,0,0,0,63.21,129.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.39,225.79a.34.34,0,0,0,0,.14c0,3.29,2.42,4.6,5.32,2.94L196.53,158a11.83,11.83,0,0,0,5.34-9.24V55.1c0-3.37-2.35-4.74-5.22-3.14l-.12.06L73.75,122.91a11.75,11.75,0,0,0-5.34,9.24v22.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.41,132.15v22.73l133.46-77V55.1c0-3.37-2.35-4.74-5.22-3.14l-.12.06L73.75,122.91A11.75,11.75,0,0,0,68.41,132.15Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.21,129.17v22.71l5.2,3V132.15a11.75,11.75,0,0,1,5.34-9.24L196.53,52s3.14-.6,3.18-.62-3.61-2.21-4.87-2.87c-.9-.49-2.17-.27-3.51.49L68.55,119.93A11.74,11.74,0,0,0,63.21,129.17Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.71,51.4s-3.61-2.21-4.87-2.87c-.9-.49-2.17-.27-3.51.49L68.55,119.93a11.41,11.41,0,0,0-4.42,5.25l5.19,3a11.41,11.41,0,0,1,4.43-5.27L196.53,52S199.67,51.42,199.71,51.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.67,140.51a.39.39,0,0,1-.32.05.24.24,0,0,1-.14-.25V129.38a.77.77,0,0,1,.14-.4,1,1,0,0,1,.32-.32l5-2.88a5.17,5.17,0,0,1,1.81-.72,1.85,1.85,0,0,1,1.17.16,1.39,1.39,0,0,1,.64.71,2.55,2.55,0,0,1,.19,1,3.64,3.64,0,0,1-.13,1,6.16,6.16,0,0,1-.33.86,6.07,6.07,0,0,1-.39.69,4,4,0,0,1-.32.44,1.61,1.61,0,0,1,1,.45,1.82,1.82,0,0,1,.44,1.39,4.85,4.85,0,0,1-.24,1.42,7.45,7.45,0,0,1-.69,1.54,8.25,8.25,0,0,1-1.14,1.48,7.18,7.18,0,0,1-1.59,1.23Zm6.52-12.19c0-.43-.14-.68-.41-.74a2,2,0,0,0-1.29.41l-3,1.73v2.61l3-1.73a4,4,0,0,0,1.29-1.08A2,2,0,0,0,85.19,128.32Zm-4.69,9,3.13-1.8A4.05,4.05,0,0,0,85,134.34a2.29,2.29,0,0,0,.43-1.29c0-.42-.15-.69-.44-.79a1.87,1.87,0,0,0-1.35.37l-3.13,1.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.21,119.11c.18-.1.31-.13.4-.09a.59.59,0,0,1,.24.3l4.15,8.3a.34.34,0,0,1,0,.11.78.78,0,0,1-.13.4,1,1,0,0,1-.32.32l-1.22.7c-.23.13-.39.18-.48.13a.33.33,0,0,1-.18-.17L97,127.65l-5.35,3.09-.73,2.3a1.42,1.42,0,0,1-.18.38,1.27,1.27,0,0,1-.48.42l-1.21.71a.41.41,0,0,1-.33,0,.24.24,0,0,1-.13-.25.3.3,0,0,1,0-.13l4.14-13.09a2.29,2.29,0,0,1,.24-.56,1,1,0,0,1,.4-.38Zm.93,6.89-1.86-3.74-1.87,5.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.24,122.86a.55.55,0,0,1-.44.1,1.1,1.1,0,0,1-.22-.11l-4.74-4.3v7a.77.77,0,0,1-.14.4,1,1,0,0,1-.32.32L102,127a.35.35,0,0,1-.32,0,.24.24,0,0,1-.14-.24V115.91a.75.75,0,0,1,.14-.4,1,1,0,0,1,.32-.33l1.18-.68a.55.55,0,0,1,.44-.1.87.87,0,0,1,.22.11l4.74,4.3v-7a.77.77,0,0,1,.14-.4,1,1,0,0,1,.32-.32l1.37-.79a.36.36,0,0,1,.32,0,.24.24,0,0,1,.14.24v10.93a.75.75,0,0,1-.14.4.92.92,0,0,1-.32.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.5,114.49a.17.17,0,0,1,.11.09.34.34,0,0,1,0,.09.73.73,0,0,1-.13.4.89.89,0,0,1-.32.32l-1.61.93a.75.75,0,0,1-.54.14l-.24-.08-4-2.19v4.42a.73.73,0,0,1-.13.4,1,1,0,0,1-.32.32l-1.38.79a.32.32,0,0,1-.32,0c-.09,0-.13-.12-.13-.24V109a.73.73,0,0,1,.13-.4.89.89,0,0,1,.32-.32l1.38-.8a.39.39,0,0,1,.32,0,.24.24,0,0,1,.13.25v4l3.69-6.2a3.25,3.25,0,0,1,.32-.45,1.77,1.77,0,0,1,.44-.36l1.56-.9a.35.35,0,0,1,.32,0,.24.24,0,0,1,.14.25.74.74,0,0,1-.1.31l-4.56,7.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.84,187.07l-2.38,1.37a.3.3,0,0,1-.28.05.21.21,0,0,1-.11-.21.71.71,0,0,1,.11-.35.83.83,0,0,1,.28-.28l.79-.45v-4c0-.22-.07-.36-.22-.42a.62.62,0,0,0-.56.08h0a.3.3,0,0,1-.28,0c-.08,0-.11-.1-.11-.21a.65.65,0,0,1,.11-.35.8.8,0,0,1,.28-.27h0a1.24,1.24,0,0,1,1.12-.19.83.83,0,0,1,.47.85v4l.79-.46a.3.3,0,0,1,.28,0,.21.21,0,0,1,.11.21.64.64,0,0,1-.12.35A.77.77,0,0,1,84.84,187.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,181.73l-1.58.91a1.66,1.66,0,0,0-.56.56,1.32,1.32,0,0,0-.23.69v.59a.11.11,0,0,0,.06.11.19.19,0,0,0,.14,0l3.37-1.95a.32.32,0,0,1,.28,0,.21.21,0,0,1,.11.21.71.71,0,0,1-.11.35.89.89,0,0,1-.28.27l-4,2.29a.31.31,0,0,1-.27.05.22.22,0,0,1-.12-.22v-1.18a2.6,2.6,0,0,1,.46-1.39,3.29,3.29,0,0,1,1.12-1.11l1.58-.91a1.69,1.69,0,0,0,.57-.56,1.34,1.34,0,0,0,.23-.69v-.8a.41.41,0,0,0-.23-.42.62.62,0,0,0-.57.09l-1.58.92a1.63,1.63,0,0,0-.56.55,1.37,1.37,0,0,0-.23.69.68.68,0,0,1-.11.35.93.93,0,0,1-.28.28.34.34,0,0,1-.28.05.22.22,0,0,1-.12-.22,2.55,2.55,0,0,1,.46-1.38,3.29,3.29,0,0,1,1.12-1.11l1.58-.92a1.28,1.28,0,0,1,1.13-.18.81.81,0,0,1,.46.85v.79a2.57,2.57,0,0,1-.46,1.38A3.35,3.35,0,0,1,90,181.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.89,177.56V178a2.6,2.6,0,0,1-.46,1.39,3.3,3.3,0,0,1-1.12,1.11l-1.58.91a1.26,1.26,0,0,1-1.12.18.81.81,0,0,1-.46-.85.68.68,0,0,1,.11-.34.83.83,0,0,1,.28-.28.34.34,0,0,1,.28,0,.22.22,0,0,1,.12.22.41.41,0,0,0,.23.42.6.6,0,0,0,.56-.09l1.58-.91a1.58,1.58,0,0,0,.56-.56,1.23,1.23,0,0,0,.23-.69V178c0-.22-.07-.36-.23-.42a.6.6,0,0,0-.56.09l-.39.23c-.12.06-.21.08-.28,0a.2.2,0,0,1-.12-.21.61.61,0,0,1,.12-.34.63.63,0,0,1,.28-.28l.39-.23a1.58,1.58,0,0,0,.56-.56,1.23,1.23,0,0,0,.23-.69v-.4a.4.4,0,0,0-.23-.42.6.6,0,0,0-.56.09l-1.58.91a1.66,1.66,0,0,0-.56.56,1.32,1.32,0,0,0-.23.69.64.64,0,0,1-.12.35.93.93,0,0,1-.28.28.3.3,0,0,1-.28,0,.21.21,0,0,1-.11-.21,2.6,2.6,0,0,1,.46-1.39A3.21,3.21,0,0,1,94.73,175l1.58-.91a1.26,1.26,0,0,1,1.12-.18.81.81,0,0,1,.46.85v.39a2.05,2.05,0,0,1-.14.74,3.9,3.9,0,0,1-.39.76.72.72,0,0,1,.39.3A1,1,0,0,1,97.89,177.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.11,175.83a.93.93,0,0,1-.28.28.34.34,0,0,1-.28,0,.22.22,0,0,1-.12-.22v-2.19a3.07,3.07,0,0,1-.79.67l-1.58.91a1.24,1.24,0,0,1-1.12.19.84.84,0,0,1-.46-.86v-2a.71.71,0,0,1,.11-.35.93.93,0,0,1,.28-.28.33.33,0,0,1,.28,0,.2.2,0,0,1,.12.21v2a.4.4,0,0,0,.23.42.6.6,0,0,0,.56-.09l1.58-.91a1.58,1.58,0,0,0,.56-.56,1.23,1.23,0,0,0,.23-.69v-2a.64.64,0,0,1,.12-.34.75.75,0,0,1,.28-.28.29.29,0,0,1,.28,0,.2.2,0,0,1,.12.21v5.53A.64.64,0,0,1,104.11,175.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.93,166.7a.11.11,0,0,0,.06.11.16.16,0,0,0,.13,0l2.18-1.26a1.26,1.26,0,0,1,1.12-.18.81.81,0,0,1,.46.85V167a2.6,2.6,0,0,1-.46,1.39,3.26,3.26,0,0,1-1.12,1.1l-1.58.92a1.26,1.26,0,0,1-1.12.18.81.81,0,0,1-.46-.85.71.71,0,0,1,.11-.35.93.93,0,0,1,.28-.28.33.33,0,0,1,.28,0,.2.2,0,0,1,.12.21.41.41,0,0,0,.23.43.67.67,0,0,0,.56-.09l1.58-.92a1.63,1.63,0,0,0,.56-.55,1.34,1.34,0,0,0,.23-.69v-.8a.41.41,0,0,0-.23-.42.6.6,0,0,0-.56.09l-2.37,1.37a.6.6,0,0,1-.56.09.4.4,0,0,1-.23-.42v-2a.62.62,0,0,1,.11-.35.93.93,0,0,1,.28-.28l4-2.28a.33.33,0,0,1,.28-.05.22.22,0,0,1,.11.21.71.71,0,0,1-.11.35,1.06,1.06,0,0,1-.28.28l-3.37,1.94a.3.3,0,0,0-.13.14.32.32,0,0,0-.06.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.05,162.79l1.58-.91a1.24,1.24,0,0,1,1.12-.19.82.82,0,0,1,.47.85v.79a2.62,2.62,0,0,1-.47,1.39,3.21,3.21,0,0,1-1.12,1.11l-1.58.91a1.24,1.24,0,0,1-1.12.19.83.83,0,0,1-.47-.85v-3.17a2.62,2.62,0,0,1,.47-1.39,3.26,3.26,0,0,1,1.12-1.1l1.58-.92a1.26,1.26,0,0,1,1.12-.18.82.82,0,0,1,.47.85.67.67,0,0,1-.12.35.8.8,0,0,1-.28.27.3.3,0,0,1-.28.05c-.08,0-.11-.11-.11-.22a.4.4,0,0,0-.24-.42.6.6,0,0,0-.56.09l-1.58.92a1.55,1.55,0,0,0-.56.55,1.28,1.28,0,0,0-.23.69v1A2.88,2.88,0,0,1,120.05,162.79Zm-.79,2.83c0,.22.07.36.23.42a.6.6,0,0,0,.56-.09l1.58-.91a1.58,1.58,0,0,0,.56-.56,1.25,1.25,0,0,0,.24-.69V163a.42.42,0,0,0-.24-.43.64.64,0,0,0-.56.1l-1.58.91a1.63,1.63,0,0,0-.56.55,1.29,1.29,0,0,0-.23.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.34,157.62,127.56,162s0,0,0,.06l0,.07,0,.09,0,.09a.47.47,0,0,1-.06.09l-.06.09a.46.46,0,0,1-.07.07.19.19,0,0,1-.07.06.36.36,0,0,1-.28.07c-.08,0-.12-.09-.12-.23a1.5,1.5,0,0,1,.2-.51c.57-1.41,1.11-2.78,1.61-4.09a2.58,2.58,0,0,0,.12-.42,3.12,3.12,0,0,0,0-.35V157a.4.4,0,0,0-.23-.42.6.6,0,0,0-.56.09l-.79.46-.4.22-1.58.92a.34.34,0,0,1-.28,0,.22.22,0,0,1-.12-.22.61.61,0,0,1,.12-.34.69.69,0,0,1,.28-.28l1.58-.92.4-.23.79-.45a1.23,1.23,0,0,1,1.12-.18.83.83,0,0,1,.46.85,2.82,2.82,0,0,1-.07.59A3,3,0,0,1,129.34,157.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.87,155.63v.4a2.59,2.59,0,0,1-.47,1.38,3.1,3.1,0,0,1-1.11,1.11l-1.59.92a1.24,1.24,0,0,1-1.11.18.83.83,0,0,1-.47-.85v-.4a2.34,2.34,0,0,1,.14-.74,3.7,3.7,0,0,1,.4-.76.71.71,0,0,1-.4-.3,1.09,1.09,0,0,1-.14-.57v-.4a2.59,2.59,0,0,1,.47-1.38,3.18,3.18,0,0,1,1.11-1.11l1.59-.92a1.24,1.24,0,0,1,1.11-.18.83.83,0,0,1,.47.85v.4a2.08,2.08,0,0,1-.15.74,3,3,0,0,1-.39.75.71.71,0,0,1,.39.31A1,1,0,0,1,135.87,155.63Zm-.79-2.31a.43.43,0,0,0-.23-.43.66.66,0,0,0-.56.09l-1.59.92a1.61,1.61,0,0,0-.55.55,1.31,1.31,0,0,0-.24.7v.39a.42.42,0,0,0,.24.43.64.64,0,0,0,.55-.09l1.59-.92a1.72,1.72,0,0,0,.56-.55,1.38,1.38,0,0,0,.23-.7Zm0,2.77a.43.43,0,0,0-.23-.43.66.66,0,0,0-.56.09l-1.59.92a1.61,1.61,0,0,0-.55.55,1.3,1.3,0,0,0-.24.69v.4a.42.42,0,0,0,.24.43.64.64,0,0,0,.55-.09l1.59-.92a1.72,1.72,0,0,0,.56-.55,1.38,1.38,0,0,0,.23-.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.94,151.21l-1.58.92a1.26,1.26,0,0,1-1.12.18.81.81,0,0,1-.46-.85.67.67,0,0,1,.12-.35.93.93,0,0,1,.28-.28.33.33,0,0,1,.28,0,.21.21,0,0,1,.11.21.43.43,0,0,0,.23.43.66.66,0,0,0,.56-.09l1.58-.92a1.66,1.66,0,0,0,.57-.55,1.38,1.38,0,0,0,.23-.7v-1a2.82,2.82,0,0,1-.8.68l-1.58.91a1.23,1.23,0,0,1-1.12.19.82.82,0,0,1-.46-.85v-.8a2.6,2.6,0,0,1,.46-1.38,3.29,3.29,0,0,1,1.12-1.11l1.58-.91a1.26,1.26,0,0,1,1.13-.19.81.81,0,0,1,.46.85v3.16a2.6,2.6,0,0,1-.46,1.39A3.15,3.15,0,0,1,146.94,151.21Zm.8-5.2a.41.41,0,0,0-.23-.43.66.66,0,0,0-.57.1l-1.58.91a1.83,1.83,0,0,0-.56.55,1.38,1.38,0,0,0-.23.7v.79a.4.4,0,0,0,.23.42.6.6,0,0,0,.56-.09l1.58-.91a1.69,1.69,0,0,0,.57-.56,1.32,1.32,0,0,0,.23-.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.87,147.79l-2.37,1.37a.34.34,0,0,1-.28.05.2.2,0,0,1-.12-.21.64.64,0,0,1,.12-.35.83.83,0,0,1,.28-.28l.79-.46V144a.41.41,0,0,0-.23-.43.64.64,0,0,0-.55.09h0a.31.31,0,0,1-.28,0,.2.2,0,0,1-.12-.21.64.64,0,0,1,.12-.35.83.83,0,0,1,.28-.28h0a1.26,1.26,0,0,1,1.12-.18.82.82,0,0,1,.46.85v4l.79-.46a.3.3,0,0,1,.28,0,.2.2,0,0,1,.12.21.64.64,0,0,1-.12.35A.8.8,0,0,1,152.87,147.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,144.82l-1.58.91a1.27,1.27,0,0,1-1.12.19.84.84,0,0,1-.46-.86V141.9a2.6,2.6,0,0,1,.46-1.39,3.39,3.39,0,0,1,1.12-1.11l1.58-.91a1.26,1.26,0,0,1,1.12-.18.81.81,0,0,1,.46.85v3.16a2.6,2.6,0,0,1-.46,1.39A3.21,3.21,0,0,1,158,144.82Zm-1.58.12L158,144a1.58,1.58,0,0,0,.38-.32l-2.75-2.2v3.1a.4.4,0,0,0,.23.42A.6.6,0,0,0,156.44,144.94Zm1.58-5.66-1.58.92a1.52,1.52,0,0,0-.38.31l2.75,2.2v-3.09a.41.41,0,0,0-.23-.43A.63.63,0,0,0,158,139.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,141.4l-2.38,1.37a.28.28,0,0,1-.27,0,.2.2,0,0,1-.12-.21.67.67,0,0,1,.12-.35.77.77,0,0,1,.27-.27l.8-.46v-4a.41.41,0,0,0-.23-.42.63.63,0,0,0-.55.08h0a.33.33,0,0,1-.28.05.21.21,0,0,1-.11-.21.71.71,0,0,1,.11-.35.93.93,0,0,1,.28-.28h0a1.26,1.26,0,0,1,1.12-.18.82.82,0,0,1,.47.85v3.95l.79-.45a.3.3,0,0,1,.28-.05.21.21,0,0,1,.11.22.68.68,0,0,1-.11.34A.83.83,0,0,1,164,141.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,135l-2.38,1.37a.33.33,0,0,1-.28,0,.21.21,0,0,1-.11-.21.71.71,0,0,1,.11-.35.93.93,0,0,1,.28-.28l.79-.46v-4a.41.41,0,0,0-.23-.43.64.64,0,0,0-.55.09h0a.28.28,0,0,1-.28,0c-.08,0-.11-.1-.11-.21a.65.65,0,0,1,.11-.35.93.93,0,0,1,.28-.28h0a1.26,1.26,0,0,1,1.12-.18.82.82,0,0,1,.46.85v4l.8-.46a.3.3,0,0,1,.28,0,.21.21,0,0,1,.11.21.64.64,0,0,1-.12.35A.77.77,0,0,1,175,135Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.17,129.66l-1.58.91a1.72,1.72,0,0,0-.56.55,1.38,1.38,0,0,0-.23.7v.59a.11.11,0,0,0,.06.11.16.16,0,0,0,.14,0l3.37-1.94a.29.29,0,0,1,.28,0,.21.21,0,0,1,.11.21.74.74,0,0,1-.11.35.89.89,0,0,1-.28.27l-4,2.29a.34.34,0,0,1-.28.05.22.22,0,0,1-.12-.22v-1.19a2.6,2.6,0,0,1,.46-1.38,3.29,3.29,0,0,1,1.12-1.11l1.58-.91a1.79,1.79,0,0,0,.57-.56,1.38,1.38,0,0,0,.23-.7v-.79a.4.4,0,0,0-.23-.42.62.62,0,0,0-.57.09l-1.58.92a1.63,1.63,0,0,0-.56.55,1.32,1.32,0,0,0-.23.69.71.71,0,0,1-.11.35.93.93,0,0,1-.28.28.33.33,0,0,1-.28,0,.2.2,0,0,1-.12-.21,2.6,2.6,0,0,1,.46-1.39,3.48,3.48,0,0,1,1.12-1.11l1.58-.91a1.29,1.29,0,0,1,1.13-.19.84.84,0,0,1,.46.86v.79a2.57,2.57,0,0,1-.46,1.38A3.27,3.27,0,0,1,180.17,129.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.1,128.61,183.73,130a.3.3,0,0,1-.28,0,.2.2,0,0,1-.12-.21.67.67,0,0,1,.12-.35.8.8,0,0,1,.28-.27l.79-.46v-4a.41.41,0,0,0-.23-.42.63.63,0,0,0-.55.08h0a.34.34,0,0,1-.28,0,.2.2,0,0,1-.12-.21.64.64,0,0,1,.12-.35.75.75,0,0,1,.28-.28h0a1.26,1.26,0,0,1,1.12-.18.81.81,0,0,1,.46.85v4l.79-.45a.31.31,0,0,1,.28,0,.22.22,0,0,1,.12.22.61.61,0,0,1-.12.34A.83.83,0,0,1,186.1,128.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.83,122.74v.4a2.6,2.6,0,0,1-.46,1.39,3.39,3.39,0,0,1-1.12,1.11l-1.58.91a1.26,1.26,0,0,1-1.12.18.81.81,0,0,1-.46-.85.59.59,0,0,1,.11-.34.75.75,0,0,1,.28-.28.3.3,0,0,1,.28-.05.21.21,0,0,1,.12.21.41.41,0,0,0,.23.43.67.67,0,0,0,.56-.09l1.58-.92a1.63,1.63,0,0,0,.56-.55,1.34,1.34,0,0,0,.23-.69v-.4a.4.4,0,0,0-.23-.42.6.6,0,0,0-.56.09l-.4.22a.3.3,0,0,1-.28,0,.21.21,0,0,1-.11-.21.74.74,0,0,1,.11-.35.93.93,0,0,1,.28-.28l.4-.22a1.76,1.76,0,0,0,.56-.56,1.32,1.32,0,0,0,.23-.69v-.4a.4.4,0,0,0-.23-.42.6.6,0,0,0-.56.09l-1.58.91a1.58,1.58,0,0,0-.56.56,1.23,1.23,0,0,0-.23.69.64.64,0,0,1-.12.35.8.8,0,0,1-.28.27.3.3,0,0,1-.28.05c-.08,0-.11-.1-.11-.21a2.6,2.6,0,0,1,.46-1.39,3.21,3.21,0,0,1,1.12-1.11l1.58-.91a1.24,1.24,0,0,1,1.12-.19.82.82,0,0,1,.46.85v.4a2.29,2.29,0,0,1-.14.74,3.7,3.7,0,0,1-.4.76.71.71,0,0,1,.4.3A1.09,1.09,0,0,1,192.83,122.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.66,145l-1.38.8a.19.19,0,0,1-.16,0c-.05,0-.07-.06-.07-.12a.35.35,0,0,1,.07-.2.44.44,0,0,1,.16-.17l.46-.26V142.8a.24.24,0,0,0-.13-.25.38.38,0,0,0-.33,0h0a.19.19,0,0,1-.17,0,.12.12,0,0,1-.06-.12.45.45,0,0,1,.06-.21.52.52,0,0,1,.17-.16h0a.74.74,0,0,1,.65-.11.49.49,0,0,1,.27.5v2.31l.46-.27a.21.21,0,0,1,.17,0,.12.12,0,0,1,.06.12.42.42,0,0,1-.06.21A.52.52,0,0,1,179.66,145Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.67,141.92l-.92.53a.92.92,0,0,0-.33.32.78.78,0,0,0-.14.41v.34a.08.08,0,0,0,0,.07.13.13,0,0,0,.08,0l2-1.13a.16.16,0,0,1,.16,0,.13.13,0,0,1,.07.13.44.44,0,0,1-.07.2.61.61,0,0,1-.16.16l-2.32,1.33a.16.16,0,0,1-.16,0,.13.13,0,0,1-.07-.12v-.7a1.56,1.56,0,0,1,.27-.81,1.83,1.83,0,0,1,.66-.64l.92-.54a.92.92,0,0,0,.33-.32.78.78,0,0,0,.14-.41v-.46A.24.24,0,0,0,183,140a.35.35,0,0,0-.33.06l-.92.53a.92.92,0,0,0-.33.32.8.8,0,0,0-.14.41.41.41,0,0,1-.06.2.49.49,0,0,1-.16.16.19.19,0,0,1-.17,0,.13.13,0,0,1-.07-.12,1.5,1.5,0,0,1,.27-.81,1.86,1.86,0,0,1,.66-.65l.92-.53a.73.73,0,0,1,.66-.11.47.47,0,0,1,.27.49v.47a1.56,1.56,0,0,1-.27.81A2,2,0,0,1,182.67,141.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.21,138.71l-.92.54a.92.92,0,0,0-.33.32.76.76,0,0,0-.13.41v.34s0,.06,0,.06a.08.08,0,0,0,.08,0l2-1.13a.17.17,0,0,1,.16,0c.05,0,.07.06.07.13a.35.35,0,0,1-.07.2.49.49,0,0,1-.16.16L186.6,141a.19.19,0,0,1-.17,0,.12.12,0,0,1-.06-.12v-.7a1.56,1.56,0,0,1,.27-.81,1.81,1.81,0,0,1,.65-.64l.92-.54a.92.92,0,0,0,.33-.32.8.8,0,0,0,.14-.41v-.46a.24.24,0,0,0-.14-.25.35.35,0,0,0-.33.06l-.92.53a.92.92,0,0,0-.33.32.78.78,0,0,0-.13.41.35.35,0,0,1-.07.2.41.41,0,0,1-.16.16.19.19,0,0,1-.17,0,.12.12,0,0,1-.06-.12,1.5,1.5,0,0,1,.27-.81,1.84,1.84,0,0,1,.65-.65l.92-.53a.73.73,0,0,1,.66-.11.47.47,0,0,1,.27.49v.47a1.5,1.5,0,0,1-.27.8A1.78,1.78,0,0,1,188.21,138.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.83,136.28v.23a1.56,1.56,0,0,1-.27.81,2,2,0,0,1-.65.65l-.93.53a.74.74,0,0,1-.65.11.49.49,0,0,1-.27-.5.35.35,0,0,1,.07-.2.41.41,0,0,1,.16-.16.17.17,0,0,1,.16,0,.11.11,0,0,1,.07.12.24.24,0,0,0,.14.25A.35.35,0,0,0,191,138l.93-.53a1,1,0,0,0,.32-.33.77.77,0,0,0,.14-.4v-.23a.24.24,0,0,0-.14-.25.36.36,0,0,0-.32,0l-.23.13a.19.19,0,0,1-.17,0,.12.12,0,0,1-.06-.12.39.39,0,0,1,.06-.2.46.46,0,0,1,.17-.17l.23-.13a.92.92,0,0,0,.32-.33.75.75,0,0,0,.14-.4v-.23a.24.24,0,0,0-.14-.25.36.36,0,0,0-.32,0l-.93.54a1,1,0,0,0-.32.32.78.78,0,0,0-.14.41.35.35,0,0,1-.07.2.49.49,0,0,1-.16.16.17.17,0,0,1-.16,0s-.07-.06-.07-.13a1.56,1.56,0,0,1,.27-.81,1.89,1.89,0,0,1,.65-.64l.93-.54a.7.7,0,0,1,.65-.1.47.47,0,0,1,.27.49v.23a1.35,1.35,0,0,1-.08.43,2.38,2.38,0,0,1-.23.45.44.44,0,0,1,.23.18A.62.62,0,0,1,192.83,136.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.66,142.71h0a.16.16,0,0,1-.13-.17l.56-4.31a.16.16,0,0,1,.17-.14.16.16,0,0,1,.14.18l-.57,4.31A.15.15,0,0,1,184.66,142.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.54,91.76v15.51a4,4,0,0,1-1.82,3.15l-16.28,9.52c-1,.58-1.82.11-1.82-1V103.38a4,4,0,0,1,1.82-3.15c4.45-2.56,11.84-7,16.28-9.52C191.73,90.13,192.54,90.6,192.54,91.76Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-166)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.54,91.76v15.51a4,4,0,0,1-1.82,3.15l-16.28,9.52c-1,.58-1.82.11-1.82-1V103.38a4,4,0,0,1,1.82-3.15c4.45-2.56,11.84-7,16.28-9.52C191.73,90.13,192.54,90.6,192.54,91.76Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.75 94.19 196.16 93.01 169.42 108.57 169 109.76 195.75 94.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.3 107.89 186.13 106.94 186.13 99.04 185.3 99.99 185.3 107.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.04 111.65 179.86 110.7 179.86 102.81 179.04 103.76 179.04 111.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.75 102.11 196.16 100.92 169.42 116.49 169 117.67 195.75 102.11",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.13,125.18a10.14,10.14,0,0,0-.92,4v22.71l5.2,3V132.15a10,10,0,0,1,.91-4Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,126.89a10.82,10.82,0,0,0-1.56,5.26v22.73h0V132.15A10.82,10.82,0,0,1,70,126.89Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.41,154.88l0,70.12c0,.31,0,.62,0,.93l.49-30.85.3-30.85c0-3.28.06-6.57.08-9.85l-.87.5Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.16,98.42,73.75,122.91a9,9,0,0,0-2.08,1.68,9,9,0,0,1,2.08-1.68Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.38,131.54a9.14,9.14,0,0,1,.34-1.7,11.39,11.39,0,0,1,1.54-3.2,10,10,0,0,1,2.41-2.53c.44-.3,1-.62,1.57-.94l1.67-1,13.38-7.67c17.77-10.36,35.58-20.62,53.31-31.05l26.57-15.68L196.65,52l-.39.21-80.1,46.25L73.75,122.91a9,9,0,0,0-2.08,1.68,12.23,12.23,0,0,0-1.7,2.3,10.82,10.82,0,0,0-1.56,5.26v22.73l.87-.5c0-7,0-14,.06-21C69.35,132.75,69.34,132.07,69.38,131.54Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.38,131.54a9.14,9.14,0,0,1,.34-1.7,11.39,11.39,0,0,1,1.54-3.2,10,10,0,0,1,2.41-2.53c.44-.3,1-.62,1.57-.94l1.67-1,13.38-7.67c17.77-10.36,35.58-20.62,53.31-31.05l26.57-15.68L196.65,52l-.39.21-80.1,46.25L73.75,122.91a9,9,0,0,0-2.08,1.68,12.23,12.23,0,0,0-1.7,2.3,10.82,10.82,0,0,0-1.56,5.26v22.73l.87-.5c0-7,0-14,.06-21C69.35,132.75,69.34,132.07,69.38,131.54Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.25,165.12l-64.16,37a4.46,4.46,0,0,0-2,3.5V206c0,1.28.9,1.81,2,1.16l64.16-37a4.49,4.49,0,0,0,2-3.5v-.32C150.27,165,149.36,164.48,148.25,165.12Z",
    style: {
      fill: "#3DBA61"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bags--inject-166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bag--inject-166"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.88,155a5,5,0,0,1,5.16.31c4.22,2.43,7.65,9.48,7.65,15.7v14.67a.67.67,0,1,1-1.33,0V171c0-5.8-3.14-12.32-7-14.55a3.72,3.72,0,0,0-3.82-.31c-1.59.92-2.5,3.26-2.5,6.41v14.6a.67.67,0,0,1-1.34,0v-14.6C299.71,159,300.87,156.19,302.88,155Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.11 239.15 274.22 168.62 285.98 161.85 289.84 227.76 270.11 239.15",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.11 239.15 274.22 168.62 285.98 161.85 289.84 227.76 270.11 239.15",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.11 239.15 274.22 168.62 285.98 161.85 289.84 227.76 270.11 239.15",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.3 185.71 331.16 251.62 289.84 227.76 285.98 161.85 327.3 185.71",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.3 185.71 331.16 251.62 289.84 227.76 285.98 161.85 327.3 185.71",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.3 185.71 331.16 251.62 289.84 227.76 285.98 161.85 327.3 185.71",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.3 185.71 315.54 192.48 311.43 263.01 331.16 251.62 327.3 185.71",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.3 185.71 315.54 192.48 311.43 263.01 331.16 251.62 327.3 185.71",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.43 263.01 319.91 251.1 320.97 209.53 322.03 250.38 331.16 251.62 311.43 263.01",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.11,239.15,311.43,263l4.11-70.53-41.32-23.86Zm31.65-47.57c0-1,.66-1.34,1.48-.87a3.28,3.28,0,0,1,1.47,2.56c0,.94-.66,1.33-1.47.86A3.21,3.21,0,0,1,301.76,191.58Zm-14.64-8.52c0-.95.66-1.34,1.47-.87a3.25,3.25,0,0,1,1.48,2.56c0,.94-.66,1.32-1.48.86A3.24,3.24,0,0,1,287.12,183.06Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.11,239.15,311.43,263l4.11-70.53-41.32-23.86Zm31.65-47.57c0-1,.66-1.34,1.48-.87a3.28,3.28,0,0,1,1.47,2.56c0,.94-.66,1.33-1.47.86A3.21,3.21,0,0,1,301.76,191.58Zm-14.64-8.52c0-.95.66-1.34,1.47-.87a3.25,3.25,0,0,1,1.48,2.56c0,.94-.66,1.32-1.48.86A3.24,3.24,0,0,1,287.12,183.06Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.1,161.74a5,5,0,0,1,5.15.3c4.22,2.44,7.66,9.49,7.66,15.71v14.67a.67.67,0,0,1-1.34,0V177.75c0-5.8-3.13-12.33-7-14.55a3.72,3.72,0,0,0-3.82-.31c-1.59.92-2.5,3.25-2.5,6.4V183.9a.67.67,0,0,1-1.34,0V169.29C287.92,165.65,289.08,162.9,291.1,161.74Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bag--inject-166"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.24,180.3a4.38,4.38,0,0,1,4.5.27c3.68,2.12,6.68,8.27,6.68,13.7v12.81a.58.58,0,1,1-1.16,0V194.27c0-5.06-2.74-10.75-6.1-12.7a3.24,3.24,0,0,0-3.34-.26c-1.38.8-2.18,2.83-2.18,5.58v12.75a.58.58,0,0,1-.58.58.59.59,0,0,1-.59-.58V186.89C265.47,183.72,266.48,181.31,268.24,180.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.64 253.71 243.22 192.16 253.49 186.25 256.86 243.77 239.64 253.71",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.64 253.71 243.22 192.16 253.49 186.25 256.86 243.77 239.64 253.71",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.56 207.08 292.92 264.6 256.86 243.77 253.49 186.25 289.56 207.08",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.56 207.08 292.92 264.6 256.86 243.77 253.49 186.25 289.56 207.08",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.56 207.08 279.29 212.99 275.7 274.54 292.92 264.6 289.56 207.08",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.56 207.08 279.29 212.99 275.7 274.54 292.92 264.6 289.56 207.08",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.7 274.54 283.11 264.15 284.03 227.87 284.95 263.52 292.92 264.6 275.7 274.54",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.64,253.71l36.06,20.82L279.29,213l-36.07-20.82Zm27.62-41.52c0-.82.58-1.16,1.29-.75a2.85,2.85,0,0,1,1.29,2.23c0,.82-.58,1.16-1.29.76A2.85,2.85,0,0,1,267.26,212.19Zm-12.78-7.43c0-.83.58-1.17,1.29-.76a2.85,2.85,0,0,1,1.29,2.23c0,.82-.58,1.16-1.29.76A2.84,2.84,0,0,1,254.48,204.76Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,186.15a4.38,4.38,0,0,1,4.49.27c3.69,2.13,6.68,8.28,6.68,13.71v12.8a.58.58,0,0,1-1.16,0v-12.8c0-5.06-2.74-10.76-6.1-12.7a3.23,3.23,0,0,0-3.33-.27c-1.39.8-2.19,2.84-2.19,5.59v12.74a.58.58,0,0,1-1.16,0V192.75C255.19,189.57,256.2,187.17,258,186.15Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-166"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.18,88.91a.81.81,0,0,0-.39-.1h-7.16l-3,1.71,1.7,11.19,3-1.71,2.56-3v7.24l2-.73,8.69-9.33a.78.78,0,0,0-.2-1.19Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.89,104.29l2-.73,8.69-9.33a.78.78,0,0,0-.59-1.29h-8.1l-2,1.71Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.89,104.29l2-.73,8.69-9.33a.78.78,0,0,0-.59-1.29h-8.1l-2,1.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.91,84.2a7.57,7.57,0,0,0-3.41-5.92h0a7.54,7.54,0,0,0-6.83,0l-32,18.33a7.57,7.57,0,0,0-3.41,5.92v26.33a7.55,7.55,0,0,0,3.41,5.91h0a7.6,7.6,0,0,0,6.83,0l32.29-18.57c3.07-1.75,3.1-3.5,3.1-5.68Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.91,84.2a7.57,7.57,0,0,0-3.41-5.92h0a7.54,7.54,0,0,0-6.83,0l-32,18.33a7.57,7.57,0,0,0-3.41,5.92v26.33a7.55,7.55,0,0,0,3.41,5.91h0a7.6,7.6,0,0,0,6.83,0l32.29-18.57c3.07-1.75,3.1-3.5,3.1-5.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.28,128.87a7.55,7.55,0,0,0,3.41,5.91h0a7.61,7.61,0,0,0,6.24.28c-1.6.61-2.83-.31-2.83-2.26V106.47a6.93,6.93,0,0,1,1-3.36l-6.82-3.94a7,7,0,0,0-1,3.37Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.8,83.23c-.4-1.45-1.72-1.91-3.3-1l-32,18.34a6.73,6.73,0,0,0-2.4,2.55l-6.82-3.93a6.88,6.88,0,0,1,2.4-2.55l32-18.34a7.62,7.62,0,0,1,6.84,0h0A7.53,7.53,0,0,1,312.8,83.23Z",
    style: {
      fill: "#3DBA61"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.4,119.26a.4.4,0,0,1-.56-.07,8.39,8.39,0,0,1-1.53-5.38,18.58,18.58,0,0,1,1.53-7.15c.27-.63.74-1,1.06-.72s.34,1,.07,1.59a14,14,0,0,0-1.16,5.41A6.36,6.36,0,0,0,287,117a1.7,1.7,0,0,1-.08,1.67A1.29,1.29,0,0,1,286.4,119.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.17,124.47a.43.43,0,0,1-.57-.07c-1.51-1.79-2.34-4.72-2.34-8.25a28.65,28.65,0,0,1,2.34-11c.28-.64.75-1,1.06-.72s.34,1,.07,1.59a24.13,24.13,0,0,0-2,9.23c0,3,.7,5.43,2,6.94a1.72,1.72,0,0,1-.07,1.67A1.49,1.49,0,0,1,283.17,124.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.6,111.06a.4.4,0,0,1-.49,0c-.31-.24-.34-1-.07-1.58a14.27,14.27,0,0,0,1.15-5.42A6.36,6.36,0,0,0,300,100a1.72,1.72,0,0,1,.07-1.67c.31-.6.79-.83,1.06-.51a8.45,8.45,0,0,1,1.53,5.4,18.7,18.7,0,0,1-1.52,7.14A1.5,1.5,0,0,1,300.6,111.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.84,112.53a.44.44,0,0,1-.5,0c-.31-.24-.34-1-.07-1.59a23.91,23.91,0,0,0,2-9.22c0-3-.7-5.43-2-6.94a1.72,1.72,0,0,1,.07-1.67c.31-.6.79-.83,1.06-.5,1.51,1.79,2.35,4.72,2.35,8.25a28.66,28.66,0,0,1-2.35,11A1.49,1.49,0,0,1,303.84,112.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.67,99.08a2.5,2.5,0,0,1,1.16,0,2.15,2.15,0,0,1,.89.49,2.55,2.55,0,0,1,.59.84,2.86,2.86,0,0,1,.22,1,.93.93,0,0,1-.09.4.52.52,0,0,1-.21.26l-1.87,1.08a.53.53,0,0,1-.32.1.52.52,0,0,1-.25-.12l-.13-.14a.6.6,0,0,0-.27-.17.91.91,0,0,0-.42,0,1.67,1.67,0,0,0-.63.24,4.8,4.8,0,0,0-.52.36,3.07,3.07,0,0,0-.45.43,2.24,2.24,0,0,0-.31.52,1.63,1.63,0,0,0-.12.62.66.66,0,0,0,.13.47.61.61,0,0,0,.46.15,4.1,4.1,0,0,0,.85-.13l1.31-.34a4.53,4.53,0,0,1,1.37-.18,1.67,1.67,0,0,1,1,.37,2,2,0,0,1,.59,1,6,6,0,0,1,.19,1.68,7.58,7.58,0,0,1-.23,1.83,8.38,8.38,0,0,1-.64,1.73,8.8,8.8,0,0,1-1,1.56,9.42,9.42,0,0,1-1.28,1.32V116a1.07,1.07,0,0,1-.12.48.77.77,0,0,1-.27.33l-1.87,1.08a.2.2,0,0,1-.27,0,.45.45,0,0,1-.12-.35v-1.62a2.7,2.7,0,0,1-1.23,0,2.16,2.16,0,0,1-.94-.48,2.28,2.28,0,0,1-.61-.89,3.63,3.63,0,0,1-.23-1.22.85.85,0,0,1,.1-.4.57.57,0,0,1,.2-.26l1.87-1.08a.55.55,0,0,1,.32-.1.36.36,0,0,1,.22.1l.18.18a.8.8,0,0,0,.3.23.83.83,0,0,0,.49.08,1.66,1.66,0,0,0,.72-.26,5.55,5.55,0,0,0,1.26-1,1.73,1.73,0,0,0,.51-1.2.48.48,0,0,0-.19-.45,1,1,0,0,0-.55-.08,5.67,5.67,0,0,0-.95.18c-.39.11-.84.22-1.37.35a2.06,2.06,0,0,1-2.14-.37,3.88,3.88,0,0,1-.68-2.63,7.32,7.32,0,0,1,.18-1.59,9.62,9.62,0,0,1,.54-1.62,8.91,8.91,0,0,1,.86-1.53,8.59,8.59,0,0,1,1.14-1.34V99a1.07,1.07,0,0,1,.12-.48.71.71,0,0,1,.27-.33l1.87-1.08a.21.21,0,0,1,.27,0,.49.49,0,0,1,.12.36Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-166"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.89,95.92c-2.74,6.56-6.56,17.37-8.84,24l-11-13H334.8s11.09,23.76,17.76,29.23c4.44,3.63,7.22.94,8.33-1.31h0c0-.08,1.89-3.33,4.32-8.25,3.16-6.38,6.53-13.37,6.53-13.37L379,86.07C373.24,85.61,367.37,87.58,363.89,95.92Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.05,119.89a39.41,39.41,0,0,1,3.38,4.61s-1.32-4.42-2.93-5.91Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,89.72h0l.88-.92v0a1.07,1.07,0,0,1,1-.21l10.65,1.81a3.81,3.81,0,0,1,2.54,2l9.58,20.82a1,1,0,0,1,0,1.11h0l-.91,1h0a1.07,1.07,0,0,1-1,.21l-10.66-1.8a3.87,3.87,0,0,1-2.54-2L332,90.87C331.71,90.36,331.76,90,332,89.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.75,114.11l-9.57-20.82a3.85,3.85,0,0,0-2.55-2L333,89.53c-1-.17-1.45.43-1,1.34l9.57,20.82a3.87,3.87,0,0,0,2.54,2l10.66,1.8C355.71,115.62,356.17,115,355.75,114.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.82,91.83a3.78,3.78,0,0,1,1.36,1.46l9.57,20.81a1,1,0,0,1,0,1.1l.86-.89h0a1,1,0,0,0,0-1.11l-9.58-20.83A3.62,3.62,0,0,0,345.8,91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.06,110.31c-4.4-5.06-4.28-11.39-2.26-13.22l1.35,2.93s6.74,1.49,10,1.25,5.9-1,6.79-.4c1.88,1.33,2.42,7-3,9C345.36,111.65,337.06,110.31,337.06,110.31Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-166"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.56,285.73a86.59,86.59,0,0,1,1.57,8.63c.42,3.27.68,5.69,1.63,11.27.86,5.09,1.52,9-2.08,12.8-3.16,3.37-8.73,4.66-10.57.83-2.1-4.37-1.82-11.47-1.54-15.89s.22-5.71.26-9.23c0-3.1.18-4.37.35-7.05C412.58,286.92,416.16,286,419.56,285.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,302.2,380.8,302c-.07-3.66.14-7-.77-8.73l1.66-4.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.84,285.53c-.27,2.5-1.69,5.08-1.79,10a41.31,41.31,0,0,0,.13,6.32l-1.21.33-.28-13.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.22,305.56s.06,1.47.69,1.95,2,1.93,8.4,1.54,8.7-2,10.9-4,2.78-7.28,3.11-9.77c.64-4.82,2.64-7.34,4.52-9.77A4.33,4.33,0,0,0,385,283s-5.32-.29-7.63,5.61-4.11,12.75-9.32,14.38A88.71,88.71,0,0,1,357.22,305.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.56,285.73c-.05-4.16,0-9.68.38-17,.43-8.53.49-15.18.46-24.22,0-6.85-.38-12.9-2.81-26,2.57-26.34,3.51-53.56.4-63.57-2.67-8.59-5.39-11.45-7.8-15.65-1.25-2.18-3.53-5.41-3.53-8.32a54,54,0,0,1-19,3.7c-12.21.11-16.48-3.2-16.48-3.2s-5.51,63.81-4.36,84.63c.68,12.33,1.67,30.57,2,39.54.28,6.91,1.08,15.91,1,19.72a31.66,31.66,0,0,1-1.94,9.72,68.41,68.41,0,0,1-4,9.85,9.85,9.85,0,0,1-1.48,2.34,26.21,26.21,0,0,1-2.73,2.65c-2,1.7-2.95,2.54-2.79,4.11s1.35,2.21,2.68,2.61c3.16.95,6.75.55,9.91,0s6.71-2.06,8.06-5.08a12,12,0,0,0,.76-2.78,39.78,39.78,0,0,1,2.42-9.19A20.82,20.82,0,0,1,382.5,286a9.15,9.15,0,0,0,2-4c.13-1.25-.84-3-2.09-4.91l0,0c-1.1-1.65-.79-2.79-.41-8,.82-11.21,3.1-19.27,5-32.88a63,63,0,0,0-.39-19.69c1.3-8.92,3.55-18.27,4.88-24.43,2.14,12.88,3.52,17.59,4.69,27.33,1.62,13.51,9.22,41.79,10.43,49.06s2,12.15,2.53,18.06c.49,5.12.87,15.43,1.51,20.12,1,7.5,8.77,5.21,10-1.41C421.49,300.82,419.62,291.48,419.56,285.73Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.46,279.36c-.91-1.62-1.75-2.08-2.64-3.47a6.93,6.93,0,0,0-2.08,3.39c-.39,1.29-1.42,7.62-3,12.65-1.17,3.78-3.13,5.78-5.83,6.81a10.78,10.78,0,0,1-5.31.59h0c-3.35-.46-2.57-2.87-2.57-2.87-.78,1.07-4,3.67-5.86,5.59-1.07,1.08-.57,2.74.25,3.8.93.8,3.11,2.41,11.11,1.25,7.1-1,8.77-4.31,9.44-5.79a35.54,35.54,0,0,0,1.47-6.67,21.16,21.16,0,0,1,2.49-7.07c.16-.27.32-.53.47-.75h0c.48-.7,1-1.48,1.68-2.25.5-.6.89-.88,1-1.46A5.35,5.35,0,0,0,384.46,279.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.38,117.77c.19,3.54,1.78,13.68,1.78,13.68,14.45,9.78,35.5-.5,35.5-.5l3.94-24S402,98.11,409,87l-11.47-.74-12.26-.06L379,86.07c-4.42,3.24-12,11.53-13.45,15.16S363,110.21,369.38,117.77Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.38,117.77c.19,3.54,1.78,13.68,1.78,13.68,14.45,9.78,35.5-.5,35.5-.5l3.94-24S402,98.11,409,87l-11.47-.74-12.26-.06L379,86.07c-4.42,3.24-12,11.53-13.45,15.16S363,110.21,369.38,117.77Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M383.56,117.18c1.25,1.63,7.05,3.62,11.83,1.5A10.79,10.79,0,0,0,402,110a9.49,9.49,0,0,1-6,10.35C388.68,123.3,383.94,118.81,383.56,117.18Z",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,75.88s21.61,8.43,21.61,4.66c4.06-7.51,12.24-9.93,12.24-23.07,0-13.71-11.38-20.41-22.78-20.41h0A20.68,20.68,0,0,0,369.27,47c-6.51,1.67-4.84,10.68,1.67,12.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.5,37.67l-1.07,5.72a2.88,2.88,0,0,0,3.49-2.23A3,3,0,0,0,404.5,37.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.8,42.43l-5.9.63a2.87,2.87,0,0,0,3.18,2.65A3.08,3.08,0,0,0,409.8,42.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.56,87V70.31s2.15,2.13,5.29-.17c2.82-2.06,4-6.5,2-8.78-1.4-1.62-5.73-2.51-7.43,1,0,0-5-.24-11.56-4.89s-8.11-8.75-12.12-9.21c-1.89,1.44-3.72,5.67-3.53,16.86.15,8.27,3.85,12.22,5.74,13.64,1.55,1.15,3.52,1.32,6.85.77v7.84S373,97.09,380.9,97.83C392.38,98.89,397.56,87,397.56,87Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.45,61.56v4.59h0a3.24,3.24,0,0,1-3.26-3.2V58.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.21,62.26a1.51,1.51,0,1,0,1.59-1.47A1.54,1.54,0,0,0,385.21,62.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.06,58l3.11-2.15a1.85,1.85,0,0,0-2.6-.51A1.94,1.94,0,0,0,372.06,58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.59,70.38,382.29,72a2.24,2.24,0,0,0,2.92,1.36A2.36,2.36,0,0,0,386.59,70.38Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.66,61.29a1.51,1.51,0,1,0,1.59-1.47A1.54,1.54,0,0,0,373.66,61.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.43 60.52 381.21 68.64 376.86 67.32 381.43 60.52",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.83,79.5c3.52-.45,10.75-2.49,11.88-5.29a7.29,7.29,0,0,1-2.54,3.58c-2.16,1.81-9.34,3.86-9.34,3.86Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.38,37.56c-7.26-1.66-10.16.45-17.5-.33-3-.32-5.77-.46-7.79.56-2.3,1.15-3.64,3.69-3.33,7,.52,5.52,6.47,6.93,6.47,6.93s5-11.35,11.74-11.26S392.38,37.56,392.38,37.56Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M369.06,260c-.09-1.5-.17-3-.22-4.36-.37-9-1.36-27.21-2-39.54-1.15-20.82,4.36-84.63,4.36-84.63s4.27,3.31,16.48,3.2a54,54,0,0,0,19-3.7c0,2.91,2.28,6.14,3.53,8.32,2.41,4.2,5.13,7.06,7.8,15.65,3.11,10,2.17,37.23-.4,63.57,2.43,13.11,2.92,19.65,3,26.5,0,9-.09,13.66-.53,22.19-4.33,3.24-13.41,1.28-13.41,1.28-1.21-7.27-8.81-35.55-10.43-49.06-1.17-9.74-2.55-14.45-4.69-27.33L386.6,216.5a63,63,0,0,1,.39,19.69c-1.39,9.9-3,16.86-4.06,24.23C381,262.45,371.94,263,369.06,260Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.86,129.46l-.13,7.1s4.68,3.58,13.26,4.15,20.63-2.8,24-5.32a11.7,11.7,0,0,1-.9-6.87,42.59,42.59,0,0,1-21.27,4.75C373.77,132.7,370.86,129.46,370.86,129.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.48,192.07l-5-29.59s-7.83-2-12-8.44a15.56,15.56,0,0,0,9.1,10.74l5.62,27.71L387,213.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.86,159.57l-.22-1-.1.07,0-.06-3.22-1.46c-.28,1.18-.6,2.76-.92,4.53-5.91,4.24-15.86,11.35-15.86,11.35l5.6,24.37,20-14.55h0a1.86,1.86,0,0,0,.77-1.17C432.53,179,427.25,163.57,425.86,159.57Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.86,159.57l-.22-1-.1.07,0-.06-3.22-1.46c-.28,1.18-.6,2.76-.92,4.53-5.91,4.24-15.86,11.35-15.86,11.35l5.6,24.37,20-14.55h0a1.86,1.86,0,0,0,.77-1.17C432.53,179,427.25,163.57,425.86,159.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.64 158.6 405.52 173.03 402.3 171.57 422.42 157.14 425.64 158.6",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.28,178.18s-.07.58,2.05.82,10.72-.71,11.8-1.5,3.75-4.83,4.88-7.49a34.29,34.29,0,0,0,1.68-5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.3,171.57c-1.27,5.3-.87,19.73-.17,21.65s2.38,2.84,4,3.58,5,2.31,5.74-.72S405.52,173,405.52,173Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.3,171.57c-1.27,5.3-.87,19.73-.17,21.65s2.38,2.84,4,3.58,5,2.31,5.74-.72S405.52,173,405.52,173Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.52,173c.06.3.86,4,1.76,5.15s11.31-.61,13.05-1.28,7.27-10.46,7.36-11.91-2.05-6.39-2.05-6.39Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.52,173c.06.3.86,4,1.76,5.15s11.31-.61,13.05-1.28,7.27-10.46,7.36-11.91-2.05-6.39-2.05-6.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.75,175c.09.46.45.57.79.26a1.63,1.63,0,0,0,.45-1.38c-.1-.45-.45-.56-.8-.25A1.57,1.57,0,0,0,419.75,175Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.52,173c-5.92-10.9-21.79-38.41-26.08-55.27s.51-26.64,3.39-31.69h-3.07c-3.53,4.33-6.88,15.36-3.88,29.41,4.26,19.89,26.42,56.09,26.42,56.09Z",
    style: {
      fill: "#3DBA61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.52,173c-5.92-10.9-21.79-38.41-26.08-55.27s.51-26.64,3.39-31.69h-3.07c-3.53,4.33-6.88,15.36-3.88,29.41,4.26,19.89,26.42,56.09,26.42,56.09Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.68,124.44c-10.72-24.09-14.29-33.51-21.1-36.33A18.4,18.4,0,0,0,408,86.92c-1.67,3.07-5.73,13.6,2.35,21.85,0,0,9.65,14.92,12.6,21.73-.73,6.59-1,14.15-3.37,23-.27,1-2,2.33-2.87,2.84-2.45,1.35-2.86,2.87-4.67,4.61-1.41,1.36-2.65,1.68-2.44,2.13a2.66,2.66,0,0,0,3.13,1.1,23.33,23.33,0,0,0,3.8-2c.23.27-2.05,3.93-4.44,6.6-3.53,3.93-4.39,6.76,2.67,7,4.42.17,9.19-3.44,12.18-12.25.59-1.74,1.21-4.26,1.83-6.71.46-1.05,5.94-20.2,6.92-25.2A9.66,9.66,0,0,0,434.68,124.44Z",
    style: {
      fill: "#ffa8a7"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg3);
export default __webpack_public_path__ + "static/media/svg-3.5726fd995a3b3661ca60cc72c537012f.svg";
export { ForwardRef as ReactComponent };